import { AdminCatalogTableColumnType, SelectOption } from "../types"
// @ts-ignore
import countryCodesMap from "./countryCodesMap.json"
import { ToastOptions } from "react-toastify"
import { NotificationIconSolid, WarningIcon } from "../components/ui/icons"
import { lowerCase, omit, startCase } from "lodash"
import { KSelectOption } from "kahuna-base-react-components/dist/components/KDropdown/KDropdown"
import AppleMusicIcon from "../components/ui/img/platforms/apple-music.svg"
import BoomplayIcon from "../components/ui/img/platforms/boom-play.svg"
import MetaIcon from "../components/ui/img/platforms/Meta.svg"
import InstagramIcon from "../components/ui/img/platforms/instagram.svg"
import RessoIcon from "../components/ui/img/platforms/resso.svg"
import SoundcloudIcon from "../components/ui/img/platforms/soundcloud.svg"
import SpotifyIcon from "../assets/release-platform-icons/SpotifyIcon.png"
import QobuzIcon from "../assets/release-platform-icons/Qobuz.png"
import TidalIcon from "../assets/release-platform-icons/Tidal.png"
import KKBoxIcon from "../assets/release-platform-icons/KKBox.png"
import AffiliateIcon from "../assets/release-platform-icons/Affiliate.png"
import TiktokIcon from "../components/ui/img/platforms/tiktok.svg"
import YoutubeIcon from "../components/ui/img/platforms/youtube.svg"
import DeezerIcon from "../components/ui/img/platforms/deezer.svg"
import FizyIcon from "../components/ui/img/platforms/fizy.svg"
import MuudIcon from "../components/ui/img/platforms/muud.svg"
import SnapIcon from "../components/ui/img/platforms/snap.svg"
import PandoraIcon from "../components/ui/img/platforms/pandora.svg"
import NcmIcon from "../components/ui/img/platforms/ncm.svg"
import AppleMusicPlatformIcon from "../assets/release-platform-icons/Apple-Music.png"
import ShazamIcon from "../assets/release-platform-icons/Shazam.png"
import SpotifyPlatformIcon from "../assets/release-platform-icons/Spotify.png"
import SevendigitalIcon from "../assets/release-platform-icons/Sevendigital.png"
import iTunesIcon from "../assets/release-platform-icons/iTunes.png"
import KeefeIcon from "../assets/release-platform-icons/Keefe.png"
import NapsterIcon from "../assets/release-platform-icons/Napster.png"
import StyngrIcon from "../assets/release-platform-icons/Styngr.png"
import ViaPathTechIcon from "../assets/release-platform-icons/ViaPath-Technologies.png"
import AmazonICon from "../assets/release-platform-icons/Amazon.png"
import AudibleMusicIcon from "../assets/release-platform-icons/Audible-Music.png"
import HuaweiMusicIcon from "../assets/release-platform-icons/Huawei-Music.png"
import JPayIcon from "../assets/release-platform-icons/JPay.png"
import BroadTimeIcon from "../assets/release-platform-icons/BroadTime.png"
import AfghanistanIcon from "../assets/country-icons/afghanistan.svg"
import AlbaniaIcon from "../assets/country-icons/albania.svg"
import AlgeriaIcon from "../assets/country-icons/algeria.svg"
import AndorraIcon from "../assets/country-icons/andorra.svg"
import AngolaIcon from "../assets/country-icons/angola.svg"
import ArgentinaIcon from "../assets/country-icons/argentina.svg"
import ArmeniaIcon from "../assets/country-icons/armenia.svg"
import AustraliaIcon from "../assets/country-icons/australia.svg"
import AustriaIcon from "../assets/country-icons/austria.svg"
import AzerbaijanIcon from "../assets/country-icons/azerbaijan.svg"
import BahrainIcon from "../assets/country-icons/bahrain.svg"
import BangladeshIcon from "../assets/country-icons/bangladesh.svg"
import BarbadosIcon from "../assets/country-icons/barbados.svg"
import BelarusIcon from "../assets/country-icons/belarus.svg"
import BelgiumIcon from "../assets/country-icons/belgium.svg"
import BoliviaIcon from "../assets/country-icons/bolivia.svg"
import BosniaAndHerzegovinaIcon from "../assets/country-icons/bosniaandherzegovina.svg"
import BrazilIcon from "../assets/country-icons/brazil.svg"
import BruneiIcon from "../assets/country-icons/brunei.svg"
import BulgariaIcon from "../assets/country-icons/bulgaria.svg"
import CambodiaIcon from "../assets/country-icons/cambodia.svg"
import CameroonIcon from "../assets/country-icons/cameroon.svg"
import CanadaIcon from "../assets/country-icons/canada.svg"
import ChileIcon from "../assets/country-icons/chile.svg"
import ChinaIcon from "../assets/country-icons/china.svg"
import ColombiaIcon from "../assets/country-icons/colombia.svg"
import CostaRicaIcon from "../assets/country-icons/costarica.svg"
import CyprusIcon from "../assets/country-icons/cpyrus.svg"
import CroatiaIcon from "../assets/country-icons/croatia.svg"
import CzechRepublicIcon from "../assets/country-icons/czechrepublic.svg"
import DemocraticCongoIcon from "../assets/country-icons/democraticcongo.svg"
import DenmarkIcon from "../assets/country-icons/denmark.svg"
import DjiboutiIcon from "../assets/country-icons/djibouti.svg"
import DominicanRepublicIcon from "../assets/country-icons/dominicanrepublic.svg"
import EcuadorIcon from "../assets/country-icons/ecuador.svg"
import EgyptIcon from "../assets/country-icons/egypt.svg"
import ElSalvadorIcon from "../assets/country-icons/elsalvador.svg"
import EnglandIcon from "../assets/country-icons/england.svg"
import EquatorialGuineaIcon from "../assets/country-icons/equatorialguinea.svg"
import EritreaIcon from "../assets/country-icons/eritrea.svg"
import EstoniaIcon from "../assets/country-icons/estonia.svg"
import EthiopiaIcon from "../assets/country-icons/ethiopia.svg"
import FinlandIcon from "../assets/country-icons/finland.svg"
import FranceIcon from "../assets/country-icons/france.svg"
import GambiaIcon from "../assets/country-icons/gambia.svg"
import GeorgiaIcon from "../assets/country-icons/georgia.svg"
import GermanyIcon from "../assets/country-icons/germany.svg"
import GhanaIcon from "../assets/country-icons/ghana.svg"
import GreeceIcon from "../assets/country-icons/greece.svg"
import GuamIcon from "../assets/country-icons/guam.svg"
import GuatemalaIcon from "../assets/country-icons/guatemala.svg"
import GuineaIcon from "../assets/country-icons/guinea.svg"
import HondurasIcon from "../assets/country-icons/honduras.svg"
import HongKongIcon from "../assets/country-icons/hongkong.svg"
import HungaryIcon from "../assets/country-icons/hungary.svg"
import IcelandIcon from "../assets/country-icons/iceland.svg"
import IndiaIcon from "../assets/country-icons/india.svg"
import IndonesiaIcon from "../assets/country-icons/indonesia.svg"
import IranIcon from "../assets/country-icons/iran.svg"
import IraqIcon from "../assets/country-icons/iraq.svg"
import IrelandIcon from "../assets/country-icons/ireland.svg"
import IsleOfManIcon from "../assets/country-icons/isleofman.svg"
import IsraelIcon from "../assets/country-icons/israel.svg"
import ItalyIcon from "../assets/country-icons/italy.svg"
import IvoryCoastIcon from "../assets/country-icons/ivorycoast.svg"
import JapanIcon from "../assets/country-icons/japan.svg"
import JordanIcon from "../assets/country-icons/jordan.svg"
import KazakhstanIcon from "../assets/country-icons/kazakhstan.svg"
import KenyaIcon from "../assets/country-icons/kenya.svg"
import KosovoIcon from "../assets/country-icons/kosovo.svg"
import KuwaitIcon from "../assets/country-icons/kuwait.svg"
import KyrgyzstanIcon from "../assets/country-icons/kyrgyzstan.svg"
import LatviaIcon from "../assets/country-icons/latvia.svg"
import LebanonIcon from "../assets/country-icons/lebanon.svg"
import LiberiaIcon from "../assets/country-icons/liberia.svg"
import LibyaIcon from "../assets/country-icons/libya.svg"
import LiechtensteinIcon from "../assets/country-icons/liechtenstein.svg"
import LithuaniaIcon from "../assets/country-icons/lithuania.svg"
import LuxembourgIcon from "../assets/country-icons/luxembourg.svg"
import MacaoIcon from "../assets/country-icons/macao.svg"
import MalaysiaIcon from "../assets/country-icons/malaysia.svg"
import MaldivesIcon from "../assets/country-icons/maldives.svg"
import MaltaIcon from "../assets/country-icons/malta.svg"
import MartiniqueIcon from "../assets/country-icons/martinique.svg"
import MauritiusIcon from "../assets/country-icons/mauritius.svg"
import MexicoIcon from "../assets/country-icons/mexico.svg"
import MoldovaIcon from "../assets/country-icons/moldova.svg"
import MongoliaIcon from "../assets/country-icons/mongolia.svg"
import MontenegroIcon from "../assets/country-icons/montenegro.svg"
import MoroccoIcon from "../assets/country-icons/morocco.svg"
import MozambiqueIcon from "../assets/country-icons/mozambique.svg"
import NamibiaIcon from "../assets/country-icons/namibia.svg"
import NepalIcon from "../assets/country-icons/nepal.svg"
import NetherlandsIcon from "../assets/country-icons/netherlands.svg"
import NewZealandIcon from "../assets/country-icons/newzealand.svg"
import NicaraguaIcon from "../assets/country-icons/nicaragua.svg"
import NigerIcon from "../assets/country-icons/niger.svg"
import NigeriaIcon from "../assets/country-icons/nigeria.svg"
import NorthMacedoniaIcon from "../assets/country-icons/northmacedonia.svg"
import NorwayIcon from "../assets/country-icons/norway.svg"
import OmanIcon from "../assets/country-icons/oman.svg"
import PakistanIcon from "../assets/country-icons/pakistan.svg"
import PalestineIcon from "../assets/country-icons/palestine.svg"
import PanamaIcon from "../assets/country-icons/panama.svg"
import ParaguayIcon from "../assets/country-icons/paraguay.svg"
import PeruIcon from "../assets/country-icons/peru.svg"
import PhilippinesIcon from "../assets/country-icons/philippines.svg"
import PolandIcon from "../assets/country-icons/poland.svg"
import PortugalIcon from "../assets/country-icons/portugal.svg"
import PuertoRicoIcon from "../assets/country-icons/puertorico.svg"
import QatarIcon from "../assets/country-icons/qatar.svg"
import RomaniaIcon from "../assets/country-icons/romania.svg"
import RussiaIcon from "../assets/country-icons/russia.svg"
import SaoTomeAndPrincipeIcon from "../assets/country-icons/saotomeandprincipe.svg"
import SaudiArabiaIcon from "../assets/country-icons/saudiarabia.svg"
import SenegalIcon from "../assets/country-icons/senegal.svg"
import SerbiaIcon from "../assets/country-icons/serbia.svg"
import SeychellesIcon from "../assets/country-icons/seychelles.svg"
import SingaporeIcon from "../assets/country-icons/singapore.svg"
import SlovakiaIcon from "../assets/country-icons/slovakia.svg"
import SloveniaIcon from "../assets/country-icons/slovenia.svg"
import SomaliaIcon from "../assets/country-icons/somalia.svg"
import SouthAfricaIcon from "../assets/country-icons/southafrica.svg"
import SouthKoreaIcon from "../assets/country-icons/southkorea.svg"
import SouthSudanIcon from "../assets/country-icons/southsudan.svg"
import SpainIcon from "../assets/country-icons/spain.svg"
import SriLankaIcon from "../assets/country-icons/srilanka.svg"
import SudanIcon from "../assets/country-icons/sudan.svg"
import SurinameIcon from "../assets/country-icons/suriname.svg"
import SwedenIcon from "../assets/country-icons/sweden.svg"
import SwitzerlandIcon from "../assets/country-icons/switzerland.svg"
import TaiwanIcon from "../assets/country-icons/taiwan.svg"
import TajikistanIcon from "../assets/country-icons/tajikistan.svg"
import TanzaniaIcon from "../assets/country-icons/tanzania.svg"
import ThailandIcon from "../assets/country-icons/thailand.svg"
import TunisiaIcon from "../assets/country-icons/tunisia.svg"
import TurkeyIcon from "../assets/country-icons/turkiye.svg"
import TurkmenistanIcon from "../assets/country-icons/turkmenistan.svg"
import UgandaIcon from "../assets/country-icons/uganda.svg"
import UnitedKingdomIcon from "../assets/country-icons/uk.svg"
import UkraineIcon from "../assets/country-icons/ukraine.svg"
import UnitedArabEmiratesIcon from "../assets/country-icons/unitedarabemirates.svg"
import UruguayIcon from "../assets/country-icons/uruguay.svg"
import UnitedStatesIcon from "../assets/country-icons/usa.svg"
import UzbekistanIcon from "../assets/country-icons/uzbekistan.svg"
import VenezuelaIcon from "../assets/country-icons/venezuela.svg"
import VietnamIcon from "../assets/country-icons/vietnam.svg"
import WalesIcon from "../assets/country-icons/wales.svg"
import YemenIcon from "../assets/country-icons/yemen.svg"
import ZimbabweIcon from "../assets/country-icons/zimbabwe.svg"
import EarthIcon from "../assets/country-icons/earth.svg"

//@ts-ignore
import SuccessIcon from "../assets/toast-icons/success.svg"
//@ts-ignore
import WarningIconNew from "../assets/toast-icons/warning.svg"
//@ts-ignore
import ErrorIcon from "../assets/toast-icons/error.svg"
//@ts-ignore
import InfoIcon from "../assets/toast-icons/info.svg"
//@ts-ignore
import EarthDarkerIcon from "../assets/admin_icons/earth.svg"
//@ts-ignore
import MusicAlbumIcon from "../assets/admin_icons/music-album.svg"
//@ts-ignore
import MusicLibraryIcon from "../assets/admin_icons/music-library.svg"
//@ts-ignore
import UserMusicIcon from "../assets/admin_icons/user-music.svg"
//@ts-ignore
import UserIcon from "../assets/admin_icons/user.svg"
//@ts-ignore
import MoneyIcon from "../assets/admin_icons/money-cash-grey.svg"
//@ts-ignore
import ReviewingIcon from "../assets/admin_icons/clock-gray.svg"
//@ts-ignore
import ActiveIcon from "../assets/admin_icons/check-circle-gray.svg"
//@ts-ignore
import DraftIcon from "../assets/admin_icons/disable-circle-gray.svg"
//@ts-ignore
import ArchivedIcon from "../assets/admin_icons/close-gray.svg"

import React from "react"
import { lang } from "./languages"
import { KSpan } from "kahuna-base-react-components"

export const TITLE_TEMPLATE = "%s - Kahuna"
export const DEFAULT_ROUTE = "/overview"
export const HEADER_PATHS: string[] = [
  "/login",
  "/forgot-password",
  "/reset-password",
  "/account/",
  "/catalog",
  "/overview",
  "/admin",
  "/analytics",
  "/daily-trends",
  "/reports",
  "/invitation",
  "/affiliate",
  "/notifications",
  "/playlists",
  "/marketing"
]

export const FOOTER_PATHS = [
  "/login",
  "/forgot-password",
  "/reset-password",
  "/account/profile",
  "/account/security",
  "/account/payment",
  "/overview",
  "/catalog",
  "/analytics",
  "/daily-trends",
  "/reports",
  "/invitation",
  "/affiliate"
]

export enum TABLE_COLUMN_TYPE {
  TEXT,
  IMG,
  LINK,
  DATE,
  CONST,
  BOOL,
  FUNCTION,
  ROW_NUMBER
}

export const RELEASE_STATUS = {
  active: (
    <div
      data-testid="status-active"
      className="bg-green-100 rounded-xl max-w-min text-green-800 text-s pl-[16px] pr-[16px] pt-[2px] pb-[2px] text-center"
    >
      Active
    </div>
  ),
  reviewing: (
    <div
      data-testid="status-reviewing"
      className="bg-blue-100 rounded-xl max-w-min text-blue-800 text-s pl-[16px] pr-[16px] pt-[2px] pb-[2px] text-center"
    >
      Reviewing
    </div>
  ),
  draft: (
    <div
      data-testid="status-draft"
      className="bg-gray-100 rounded-xl max-w-min text-gray-800 text-s pl-[16px] pr-[16px] pt-[2px] pb-[2px] text-center"
    >
      Draft
    </div>
  ),
  archived: (
    <div
      data-testid="status-archived"
      className="bg-red-100 rounded-xl max-w-min text-red-800 text-s pl-[16px] pr-[16px] pt-[2px] pb-[2px] text-center"
    >
      Archived
    </div>
  )
}

export const ID_SECRET_PHRASE = "4d657373616765"
export const INPUT_DECORATION = {
  HTTPS: "https://"
}

export const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/

/*Table Styles*/

export const tableCellClasses = {
  sm: "pt-2 pb-2 pl-4 pr-4 text-xs",
  md: "pt-3 pb-3 pl-6 pr-6 text-[13px]",
  lg: "pt-4 pb-4 pl-7 pr-7 text-[14px]"
}

export const tableTitleClasses = {
  sm: "text-l leading-3",
  md: "text-xl leading-5",
  lg: "text-2xl leading-7"
}

export const buttonClasses = {
  sm: "text-xs",
  md: "text-sm",
  lg: "text-base"
}

export const ASSET_TYPES = {
  TRACK: "track",
  YOUTUBE_VIDEO: "youtubeVideo"
}

export const UNAUTHORIZED_ERROR_NAME = "Unauthorized"

export const monthList = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
]
export const monthShortList = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

export const ANALYSIS_FILTER = {
  TOP_TRACKS: "topTracks",
  TOP_PLATFORMS: "platform",
  TOP_COUNTRIES: "storeFront",
  ALL_PLATFORM_TOTAL: "allPlatformTotal",
  ALL_ACCOUNTS: "allAccounts",
  USER_BALANCE: "userBalance"
}

export const PAYMENT_PERIOD_TYPE_ID = {
  QUARTERLY: 1,
  MONTHLY: 2
}

export const PAYMENT_PERIOD_TYPE = {
  1: "QUARTERLY",
  2: "MONTHLY"
}

export const analysisFilterOptions: KSelectOption[] = [
  {
    value: 2,
    value2: ANALYSIS_FILTER.TOP_PLATFORMS,
    label: "Filtered by platforms",
    icon: MusicLibraryIcon
  },
  {
    value: 1,
    value2: ANALYSIS_FILTER.TOP_TRACKS,
    label: "Filtered by tracks",
    icon: MusicAlbumIcon
  },
  {
    value: 3,
    value2: ANALYSIS_FILTER.TOP_COUNTRIES,
    label: "Filtered by countries",
    icon: EarthDarkerIcon
  },
  {
    value: 4,
    value2: ANALYSIS_FILTER.ALL_PLATFORM_TOTAL,
    label: "All platform totals",
    icon: UserMusicIcon
  },
  {
    value: 5,
    value2: ANALYSIS_FILTER.ALL_ACCOUNTS,
    label: "All accounts",
    icon: UserIcon
  },
  {
    value: 6,
    value2: ANALYSIS_FILTER.USER_BALANCE,
    label: "User Balance",
    icon: MoneyIcon
  }
]

export const analysisFilterOptionsKDropdown: KSelectOption[] = [
  {
    value: 0,
    value2: ANALYSIS_FILTER.TOP_PLATFORMS,
    label: "Filtered by platforms"
  },
  {
    value: 1,
    value2: ANALYSIS_FILTER.TOP_TRACKS,
    label: "Filtered by tracks"
  },
  {
    value: 2,
    value2: ANALYSIS_FILTER.TOP_COUNTRIES,
    label: "Filtered by countries"
  }
]

export const pieChartColorList = [
  "#F0FED8",
  "#E4DFFF",
  "#FFF1E9",
  "#FAE1EE",
  "#AFEDFA",
  "#CBFFEC",
  "#D7FFC4",
  "#AFB6FA",
  "#FFDACB",
  "#ef5b5b"
]

export const platformIcons = {
  "snp-snap": SnapIcon,
  tiktok: TiktokIcon,
  "res-resso": RessoIcon,
  "spo-spotify": SpotifyIcon,
  youtube: YoutubeIcon,
  Amazon: AmazonICon,
  Qobuz: QobuzIcon,
  Tidal: TidalIcon,
  KKBox: KKBoxIcon,
  "YouTube - Audio Tier": YoutubeIcon,
  "Metafbk-facebook": MetaIcon,
  "Meta-instagram": InstagramIcon,
  "apl-apple": AppleMusicIcon,
  "boo-boomplay": BoomplayIcon,
  "dzr-deezer": DeezerIcon,
  "pnd-pandora": PandoraIcon,
  "scu-soundcloud": SoundcloudIcon,
  "ncm-netease-cloud-music": NcmIcon,
  "Fizy - Fizy": FizyIcon,
  "Muud - Muud": MuudIcon,
  Affiliate: AffiliateIcon
}

export const platformColors = {
  "snp-snap": "#FFC107",
  tiktok: "#5AD7E0",
  "res-resso": "#FF3D6E",
  "spo-spotify": "#1DB954",
  youtube: "#E53935",
  Amazon: "#6D4AFF",
  Qobuz: "#2AA5A0",
  Tidal: "#2E3A59",
  KKBox: "#2FB8FF",
  "YouTube - Audio Tier": "#FF6B6B",
  "Metafbk-facebook": "#1877F2",
  "Meta-instagram": "#E1306C",
  "apl-apple": "#FF3B5C",
  "boo-boomplay": "#00FFFF",
  "dzr-deezer": "#9B6DFF",
  "pnd-pandora": "#2D6BFF",
  "scu-soundcloud": "#FF6A00",
  "ncm-netease-cloud-music": "#E11D2E",
  "Fizy - Fizy": "#FFD233",
  "Muud - Muud": "#9C27B0",
  Affiliate: "#9AA0A6"
}

export const trendsIcons = {
  spotify: SpotifyIcon,
  facebook: MetaIcon,
  instagram: InstagramIcon,
  apple: AppleMusicIcon
}

export const chartLabels = {
  [ANALYSIS_FILTER.TOP_TRACKS]: { null: "Other tracks total" },
  [ANALYSIS_FILTER.TOP_PLATFORMS]: {
    top_songs: lang.common.chartLabels.platform_options_top_songs,
    "snp-snap": "Snapchat",
    tiktok: "TikTok",
    Amazon: "Amazon",
    Qobuz: "Qobuz",
    Tidal: "Tidal",
    KKBox: "KKBox",
    "res-resso": "Resso",
    "spo-spotify": "Spotify",
    youtube: "YouTube",
    "YouTube - Audio Tier": "YouTube - Audio Tier",
    "Metafbk-facebook": "Meta Facebook",
    "Meta-instagram": "Meta Instagram",
    "apl-apple": "Apple Music",
    "boo-boomplay": "Boomplay",
    "dzr-deezer": "Deezer",
    "pnd-pandora": "Pandora",
    "scu-soundcloud": "Soundcloud",
    "ncm-netease-cloud-music": "NetEase Cloud Music",
    "Fizy - Fizy": "Fizy",
    "Muud - Muud": "Muud",
    Affiliate: "Affiliate"
  },
  [ANALYSIS_FILTER.TOP_COUNTRIES]: {
    ...countryCodesMap.reduce((map, obj) => {
      map[obj.Code] = obj.Name
      return map
    }, {}),
    "N/A": "Other countries total",
    "": "Not Available"
  }
}

export enum TOAST_TYPES {
  SuccessFilled = "success-filled",
  SuccessStroke = "success-stroke",
  ErrorFilled = "error-filled",
  ErrorStroke = "error-stroke",
  WarningFilled = "warning-filled",
  WarningStroke = "warning-stroke",
  InfoFilled = "info-filled",
  InfoStroke = "info-stroke",
  Other = "other"
}

export const toastTextColors = {
  "success-filled": {
    titleColor: "rgba(22, 56, 39, 1)",
    contentColor: "rgba(22, 56, 39, 0.8)"
  },
  "error-filled": {
    titleColor: "rgba(64, 22, 26, 1)",
    contentColor: "rgba(64, 22, 26, 0.8)"
  },
  "warning-filled": {
    titleColor: "rgba(64, 38, 22, 1)",
    contentColor: "rgba(64, 38, 22, 0.8)"
  },
  "info-filled": {
    titleColor: "rgba(22, 43, 64, 1)",
    contentColor: "rgba(22, 43, 64, 0.8)"
  },
  // success-stroke, error-stroke, warning-stroke, info-stroke and other font colors are same. So they are collected in the same prop.
  // use those types with CustomToastContent.
  other: {
    titleColor: "rgba(0, 0, 0, 1)",
    contentColor: "rgba(0, 0, 0, 0.8)"
  }
}

// use only if the toastContent includes a title too. If just content no need to use this.
export const CustomToastContent = (content: string, title?: string, type?: string) => {
  const toastType = type || TOAST_TYPES.Other
  const titleColor = toastTextColors[toastType]?.titleColor || "#000"
  const contentColor = toastTextColors[toastType]?.contentColor || "rgba(0, 0, 0, 0.8)"

  return (
    <div className="flex flex-col">
      {title && <KSpan text={title} fontWeight={500} color={titleColor} />}
      <KSpan text={content} fontWeight={400} color={contentColor} />
    </div>
  )
}

export const successFilledToastOptions: ToastOptions = {
  className: "custom-toast",
  position: "top-right",
  hideProgressBar: true,
  autoClose: 4000,
  closeButton: false,
  icon: <img src={SuccessIcon} width={44} height={44} />,
  style: {
    backgroundColor: "#ECFBF0",
    borderRadius: "10px",
    color: "#163827",
    fontFamily: "Inter",
    fontSize: "14px",
    padding: "10px",
    lineHeight: "20px",
    fontWeight: "500"
  }
}

export const successStrokeToastOptions: ToastOptions = {
  className: "custom-toast",
  position: "top-right",
  hideProgressBar: true,
  autoClose: 4000,
  closeButton: false,
  icon: <img src={SuccessIcon} width={44} height={44} />,
  style: {
    backgroundColor: "#FFF",
    borderRadius: "10px",
    boxShadow:
      "0px 32px 24px -12px rgba(17, 17, 17, 0.06), 0px 11px 4px 0px rgba(17, 17, 17, 0.01), 0px 6px 4px 0px rgba(17, 17, 17, 0.02), 0px 3px 3px 0px rgba(17, 17, 17, 0.03), 0px 1px 1px 0px rgba(17, 17, 17, 0.04), 0px 0px 0px 1px rgba(17, 17, 17, 0.04)",
    color: "#000",
    fontFamily: "Inter",
    fontSize: "14px",
    padding: "10px",
    lineHeight: "20px"
  }
}

export const errorFilledToastOptions: ToastOptions = {
  className: "custom-toast",
  position: "top-right",
  hideProgressBar: true,
  autoClose: 4000,
  closeButton: false,
  icon: <img src={ErrorIcon} width={44} height={44} />,
  style: {
    backgroundColor: "#FFE6E8",
    borderRadius: "10px",
    color: "#40161A",
    fontFamily: "Inter",
    fontSize: "14px",
    padding: "10px",
    lineHeight: "20px",
    fontWeight: "500"
  }
}

export const errorStrokeToastOptions: ToastOptions = {
  className: "custom-toast",
  position: "top-right",
  hideProgressBar: true,
  autoClose: 4000,
  closeButton: false,
  icon: <img src={ErrorIcon} width={44} height={44} />,
  style: {
    backgroundColor: "#FFF",
    borderRadius: "10px",
    boxShadow:
      "0px 32px 24px -12px rgba(17, 17, 17, 0.06), 0px 11px 4px 0px rgba(17, 17, 17, 0.01), 0px 6px 4px 0px rgba(17, 17, 17, 0.02), 0px 3px 3px 0px rgba(17, 17, 17, 0.03), 0px 1px 1px 0px rgba(17, 17, 17, 0.04), 0px 0px 0px 1px rgba(17, 17, 17, 0.04)",
    color: "#000",
    fontFamily: "Inter",
    fontSize: "14px",
    padding: "10px",
    lineHeight: "20px"
  }
}

export const warningFilledToastOptions: ToastOptions = {
  className: "custom-toast",
  position: "top-right",
  hideProgressBar: true,
  autoClose: 4000,
  closeButton: false,
  icon: <img src={WarningIconNew} width={44} height={44} />,
  style: {
    backgroundColor: "#FFEFE6",
    borderRadius: "10px",
    color: "#402616",
    fontFamily: "Inter",
    fontSize: "14px",
    padding: "10px",
    lineHeight: "20px",
    fontWeight: "500"
  }
}

export const warningStrokeToastOptions: ToastOptions = {
  className: "custom-toast",
  position: "top-right",
  hideProgressBar: true,
  autoClose: 4000,
  closeButton: false,
  icon: <img src={WarningIconNew} width={44} height={44} />,
  style: {
    backgroundColor: "#FFF",
    borderRadius: "10px",
    boxShadow:
      "0px 32px 24px -12px rgba(17, 17, 17, 0.06), 0px 11px 4px 0px rgba(17, 17, 17, 0.01), 0px 6px 4px 0px rgba(17, 17, 17, 0.02), 0px 3px 3px 0px rgba(17, 17, 17, 0.03), 0px 1px 1px 0px rgba(17, 17, 17, 0.04), 0px 0px 0px 1px rgba(17, 17, 17, 0.04)",
    color: "#000",
    fontFamily: "Inter",
    fontSize: "14px",
    padding: "10px",
    lineHeight: "20px"
  }
}

export const infoFilledToastOptions: ToastOptions = {
  className: "custom-toast",
  position: "top-right",
  hideProgressBar: true,
  autoClose: 4000,
  closeButton: false,
  icon: <img src={InfoIcon} width={44} height={44} />,
  style: {
    backgroundColor: "#E6F2FF",
    borderRadius: "10px",
    color: "#162B40",
    fontFamily: "Inter",
    fontSize: "14px",
    padding: "10px",
    lineHeight: "20px",
    fontWeight: "500"
  }
}

export const infoStrokeToastOptions: ToastOptions = {
  className: "custom-toast",
  position: "top-right",
  hideProgressBar: true,
  autoClose: 4000,
  closeButton: false,
  icon: <img src={InfoIcon} width={44} height={44} />,
  style: {
    backgroundColor: "#FFF",
    borderRadius: "10px",
    boxShadow:
      "0px 32px 24px -12px rgba(17, 17, 17, 0.06), 0px 11px 4px 0px rgba(17, 17, 17, 0.01), 0px 6px 4px 0px rgba(17, 17, 17, 0.02), 0px 3px 3px 0px rgba(17, 17, 17, 0.03), 0px 1px 1px 0px rgba(17, 17, 17, 0.04), 0px 0px 0px 1px rgba(17, 17, 17, 0.04)",
    color: "#000",
    fontFamily: "Inter",
    fontSize: "14px",
    padding: "10px",
    lineHeight: "20px"
  }
}

export const adminTableLimit = 10

export const ROLES = {
  AUTHOR: 1,
  ARRANGER: 2,
  CONTRIBUTOR: 3,
  FEATURING: 4,
  REMIXER: 5,
  LYRICIST: 6,
  COMPOSER: 7,
  PRODUCER: 8,
  OTHER: 9,
  MAIN_OWNER: 10
}

export const ROLE_NAMES: any = {
  1: "Author",
  2: "Arranger",
  3: "Contributor",
  4: "Feauturing",
  5: "Remixer",
  6: "Lyricist",
  7: "Composer",
  8: "Producer",
  9: "Partial Owner",
  10: "Main Owner"
}

export const roleOptions = Object.keys(omit(ROLES, ["MAIN_OWNER"])).map((key) => ({
  label: startCase(lowerCase(key)),
  value: ROLES[key]
}))

export const completeRoleOptions = Object.keys(ROLES).map((key) => ({
  label: startCase(lowerCase(key)),
  value: ROLES[key]
}))

export const avatarColorList = ["#F7F7F7", "#111111", "#D5E9FF", "#D5FFFD", "#DECAFE", "#FFD5D8"]

export const avatarFontColorList = ["#111111", "#FFFFFF", "#162B40", "#16403E", "#1F0C3F", "#40161A"]

export const getRandomAvatarIndex = (index?: number) => {
  if (index) {
    const randomIndex = index % 6
    return randomIndex
  } else {
    const randomIndex = Math.floor(Math.random() * avatarColorList.length)
    return randomIndex
  }
}

export const RELEASE_FILTER = {
  ALL: "all",
  OWNER: "owner",
  CONTRIBUTOR: "contributor"
}

export const defaultTopSongsFilter = "top_songs"

export const topSongsFilterOptions: SelectOption[] = [
  {
    value: "top_songs",
    label: "All Platforms"
  },
  {
    value: "apl-apple",
    label: "Apple Music"
  },
  {
    value: "res-resso",
    label: "Resso"
  },
  {
    value: "snp-snap",
    label: "Snapchat"
  },
  {
    value: "boo-boomplay",
    label: "Boomplay"
  },
  {
    value: "spo-spotify",
    label: "Spotify"
  },
  {
    value: "Metafbk-facebook",
    label: "Meta"
  },
  {
    value: "tiktok",
    label: "TikTok"
  },
  {
    value: "scu-soundcloud",
    label: "Soundcloud"
  },
  {
    value: "youtube",
    label: "YouTube"
  }
]

export enum USER_ROLE {
  SuperAdmin = 1,
  DistroAdmin = 2,
  Artist = 3,
  Collaborator = 4,
  Affiliate = 5,
  MarketingAdmin = 6,
  AccountingAdmin = 7,
  DistroAdminAssistant = 8,
  BrandAmbassador = 9,
  CustomAdmin = 10
}

export const allRoleList = [
  USER_ROLE.SuperAdmin,
  USER_ROLE.DistroAdmin,
  USER_ROLE.DistroAdminAssistant,
  USER_ROLE.AccountingAdmin,
  USER_ROLE.MarketingAdmin,
  USER_ROLE.CustomAdmin,
  USER_ROLE.Artist,
  USER_ROLE.Collaborator,
  USER_ROLE.Affiliate,
  USER_ROLE.BrandAmbassador
]

export const regularRoleList = [
  USER_ROLE.SuperAdmin,
  USER_ROLE.DistroAdmin,
  USER_ROLE.DistroAdminAssistant,
  USER_ROLE.AccountingAdmin,
  USER_ROLE.MarketingAdmin,
  USER_ROLE.CustomAdmin,
  USER_ROLE.Artist,
  USER_ROLE.Collaborator
]

export const adminRoleList = [
  USER_ROLE.SuperAdmin,
  USER_ROLE.DistroAdmin,
  USER_ROLE.DistroAdminAssistant,
  USER_ROLE.MarketingAdmin,
  USER_ROLE.AccountingAdmin,
  USER_ROLE.CustomAdmin
]

export const artistRoleList = [USER_ROLE.Artist, USER_ROLE.Collaborator, USER_ROLE.Affiliate, USER_ROLE.BrandAmbassador]

export const userRoleOptions = [
  { label: "Super Admin", value: USER_ROLE.SuperAdmin },
  { label: "Distro Admin", value: USER_ROLE.DistroAdmin },
  { label: "Distro Admin Assistant", value: USER_ROLE.DistroAdmin },
  { label: "Accouting Admin", value: USER_ROLE.AccountingAdmin },
  { label: "Marketing Admin", value: USER_ROLE.MarketingAdmin },
  { label: "Custom Admin", value: USER_ROLE.CustomAdmin },
  { label: "Artist", value: USER_ROLE.Artist },
  { label: "Collaborator", value: USER_ROLE.Collaborator },
  { label: "Affiliate", value: USER_ROLE.Affiliate },
  { label: "Brand Ambassador", value: USER_ROLE.BrandAmbassador }
]

export const superAdminSelectOption = [{ label: "Super Admin", value: USER_ROLE.SuperAdmin }]

export enum PERMISSIONS {
  NewRelease = 1,
  GetAdvance = 2
}

export const DEFAULT_ROUTES = {
  [USER_ROLE.SuperAdmin]: "/admin/reports-approval",
  [USER_ROLE.DistroAdmin]: "/admin/user-asset",
  [USER_ROLE.DistroAdminAssistant]: "/admin/catalog",
  [USER_ROLE.MarketingAdmin]: "/admin/catalog",
  [USER_ROLE.AccountingAdmin]: "/admin/reports-approval",
  [USER_ROLE.Artist]: "/overview",
  [USER_ROLE.Collaborator]: "/overview",
  [USER_ROLE.Affiliate]: "/overview",
  [USER_ROLE.BrandAmbassador]: "/overview"
}

export enum COLLAB_INVITATION_TABLE_ROW_STATUS {
  Active = "1",
  Pending = "2",
  Expired = "3",
  Accepted = "4",
  NotPublished = "5"
}

export const collaboratorInvitationStatus = {
  [COLLAB_INVITATION_TABLE_ROW_STATUS.Active]: { text: "Active", icon: "/catalog_icons/active-status.svg" },
  [COLLAB_INVITATION_TABLE_ROW_STATUS.Pending]: { text: "Pending", icon: "/catalog_icons/reviewing-status.svg" },
  [COLLAB_INVITATION_TABLE_ROW_STATUS.Expired]: { text: "Expired", icon: "/catalog_icons/archived-status.svg" },
  [COLLAB_INVITATION_TABLE_ROW_STATUS.Accepted]: { text: "Accepted", icon: "/catalog_icons/draft-status.svg" },
  [COLLAB_INVITATION_TABLE_ROW_STATUS.NotPublished]: { text: "Not Published", icon: "/catalog_icons/draft-status.svg" }
}

export enum INVITATION_STATUS {
  AcceptRegistered = 1,
  AcceptUnregistered = 2,
  AlreadyAccepted = 3,
  Expired = 4,
  TokenUnrecognized = 5
}

export const INVITATION_ACCEPT_TITLE = {
  [INVITATION_STATUS.AcceptRegistered]: "You accepted invitation!",
  [INVITATION_STATUS.AcceptUnregistered]: "Welcome to the club!",
  [INVITATION_STATUS.AlreadyAccepted]: "Something's wrong!",
  [INVITATION_STATUS.Expired]: "Something's wrong!",
  [INVITATION_STATUS.TokenUnrecognized]: "Something's wrong!"
}

export const INVITATION_ACCEPT_TEXT = {
  [INVITATION_STATUS.AcceptRegistered]:
    "Congratulations! 🎉\n" +
    "\n" +
    "You've successfully accepted this invitation, and as a registered user, you can now access your royalty share information via our dashboard.\n" +
    "\n" +
    "Simply log in to your account to explore your royalty share details and make the most of our platform's features.",
  [INVITATION_STATUS.AcceptUnregistered]:
    "Congratulations! 🎉\n" +
    "\n" +
    "You've successfully accepted this invitation. You will recieve your log in credentials via email soon.\n" +
    "\n" +
    "We're excited to have you on board and look forward to helping you navigate your royalty share journey with ease. Happy exploring!",
  [INVITATION_STATUS.AlreadyAccepted]:
    "Uh-oh, it looks like you've already accepted this invitation 🙌\n" +
    "\n" +
    "The invitation link you clicked on from your email has already approved, as you've previously accepted it.\n" +
    "\n" +
    "If you're experiencing any issues or need assistance with your account, please feel free to reach out to our support.",
  [INVITATION_STATUS.Expired]:
    "Oops, it seems this invitation has expired ⌛\n" +
    "\n" +
    "The invitation link you clicked on from your email has expired, and unfortunately, we can no longer process it. These links typically have a limited timeframe of 28 days for activation.\n" +
    "\n" +
    "If you still wish to access your royalty share information or have any questions, please don't hesitate to contact our support.",
  [INVITATION_STATUS.TokenUnrecognized]:
    "Oops! It seems there's been a hiccup 🙁\n" +
    "\n" +
    "The invitation link you clicked on from your email appears to be corrupt and we couldn't recognize it.\n" +
    "\n" +
    "Please kindly contact our support for further assistance."
}

export const spotifyEditorialPitchingGenreOptions = [
  "Blues",
  "Children's",
  "Classical",
  "Country",
  "Electronic",
  "Folk",
  "Hip-Hop/Rap",
  "Jazz",
  "Latin Music",
  "Metal",
  "New Age",
  "Pop",
  "Punk",
  "R&B",
  "Reggae",
  "Rock",
  "Soul",
  "Soundtracks",
  "Video",
  "World"
]

export const spotifyEditorialPitchingMoodOptions = [
  "Chill",
  "Energetic",
  "Happy",
  "Fierce",
  "Meditative",
  "Romantic",
  "Sad",
  "Sexy",
  "None of these"
]
export const spotifyEditorialPitchingStyleOptions = [
  "Acoustic",
  "Ballad",
  "Beats",
  "Christmas",
  "Experimental",
  "Holiday",
  "Traditional",
  "None of these"
]
export const spotifyEditorialPitchingInstrumentionOptions = [
  "Accordion",
  "Acoustic Guitar",
  "Banjo",
  "Bass Guitar",
  "Bouzouki",
  "Cello",
  "Clarinet",
  "Djembe",
  "Drums",
  "Electric Guitar",
  "Erhu",
  "Flute",
  "Harmonica",
  "Harp",
  "Kora",
  "Mandolin",
  "Mbira",
  "Oboe",
  "Organ",
  "Oud",
  "Pedal Steel Guitar",
  "Piano",
  "Samples",
  "Sanxian",
  "Sarod",
  "Saxophone",
  "Sitar",
  "Steel Drum",
  "Synthesizer",
  "Tabla",
  "Trombone",
  "Trumpet",
  "Ukulele",
  "Violin",
  "Xylophone"
]

export enum USER_PERMISSION {
  NEW_RELEASE = 1,
  GET_ADVANCE = 2,
  UPLOAD_BMV = 3,
  UPLOAD_STATE51 = 4,
  UPLOAD_MESAM = 5,
  UPLOAD_MSG = 6,
  UPLOAD_MARKETING = 7,
  MANUEL_ISRC_ENTRY = 8,
  DO_NOT_SEND_STATE51_YOUTUBE_CONTENT_ID = 9,
  NEW_RELEASE_CREATE_VIDEO = 10,
  DO_NOT_SEND_STATE51_YOUTUBE_MUSIC_ART = 11,
  DO_NOT_SEND_STATE51_MUUD = 12,
  DO_NOT_SEND_STATE51_FIZY = 13,
  DO_NOT_SEND_STATE51_BEATPORT = 14
}

export enum CURRENCY_TYPES {
  TRY = 1,
  USD = 2,
  EUR = 3,
  GBP = 4,
  USD_GBP = 5
}

export const currencyOptions = [
  { label: "GBP", value: 4, value2: "GBP" },
  { label: "TRY", value: 1, value2: "TRY" },
  { label: "EUR", value: 3, value2: "EUR" },
  { label: "USD", value: 2, value2: "USD" }
]

export const platforms: string[] = [
  "iTunes",
  "Shazam",
  "Apple Music",
  "Spotify",
  "Amazon",
  "Napster",
  "Huawei Music",
  "Audible Music",
  "BroadTime",
  "ViaPath Technologies",
  "JPay",
  "Keefe",
  "Styngr",
  "7digital"
]
export const releasePlatformIcons = {
  iTunes: iTunesIcon,
  Shazam: ShazamIcon,
  "Apple Music": AppleMusicPlatformIcon,
  Spotify: SpotifyPlatformIcon,
  Amazon: AmazonICon,
  Napster: NapsterIcon,
  "Huawei Music": HuaweiMusicIcon,
  "Audible Music": AudibleMusicIcon,
  BroadTime: BroadTimeIcon,
  "ViaPath Technologies": ViaPathTechIcon,
  JPay: JPayIcon,
  Keefe: KeefeIcon,
  Styngr: StyngrIcon,
  SevenDigital: SevendigitalIcon
}
/*export const state51GenreMapping = {
  "Blues : Acoustic Blues": "Blues",
  "Blues : Blues Rock": "Blues",
  "Blues : Punk Blues": "Blues",
  "Blues : Soul Blues": "Blues",
  "Blues : Traditional": "Blues",
  "Blues : Soul/R&B": "Blues",
  "Children's : Children's": "Children's",
  "Classical : Classical": "Classical",
  "Classical : Film Music": "Classical",
  "Classical : Other": "Classical",
  "Country : Country": "Country",
  "Country : Other": "Country",
  "Electronic : Dance": "Dance",
  "Electronic : Dance-Pop": "Dance",
  "Electronic : DJ": "Electronic",
  "Electronic : Downbeat": "Electronic",
  "Electronic : Electro": "Electronic",
  "Electronic : House": "Electronic",
  "Electronic : I.D.M": "Electronic",
  "Electronic : Other": "Electronic",
  "Electronic : Trip Hop": "Electronic",
  "Folk : Acoustic": "Folk",
  "Folk : Alternative Folk": "Folk",
  "Folk : Folk": "Folk",
  "Folk : Folk Singer/Songwriter": "Folk",
  "Folk : Traditional Folk": "Folk",
  "Hip-Hop/Rap : Alternative Rap": "Hip-Hop/Rap",
  "Hip-Hop/Rap : Other": "Hip-Hop/Rap",
  "Hip-Hop/Rap : R&B": "Hip-Hop/Rap",
  "Hip-Hop/Rap : Rap": "Hip-Hop/Rap",
  "Jazz : Classic Jazz": "Jazz",
  "Jazz : Contemporary Jazz": "Jazz",
  "Jazz : Jazz": "Jazz",
  "Jazz : Jazz/Blues": "Jazz",
  "Jazz : Other": "Jazz",
  "Latin Music : Latin Music": "Latin",
  "Metal : Metal": "Metal",
  "Metal : Other": "Metal",
  "New Age : Other": "New Age",
  "Pop : Dance-Pop": "Dance",
  "Pop : Indie Pop": "Indo Pop",
  "Pop : Other": "Pop",
  "Pop : Pop": "Pop",
  "Pop : Pop Singer/Songwriter": "Singer/Songwriter",
  "Punk : Punk": "Punk",
  "R&B : Neo-Soul": "R&B",
  "R&B : Other": "R&B",
  "R&B : Soul": "R&B",
  "Reggae : Other": "Reggae",
  "Reggae : Reggae": "Reggae",
  "Reggae : Ska": "Reggae",
  "Rock : Pop-Rock": "Rock",
  "Rock : Rock": "Rock",
  "Rock : Rock'n Roll": "Rock",
  "Rock : Rock Singer/Songwriter": "Rock",
  "Soul : Modern Soul": "Rock",
  "Soul : Soul": "Soul",
  "Soul : LoFi": "Soul",
  "Soundtracks : Film Soundtracks": "Soundtrack",
  "Soundtracks : Original Score": "Soundtrack",
  "Soundtracks : Other": "Soundtrack",
  "Soundtracks : Soundtracks": "Soundtrack",
  "Soundtracks : TV Soundtracks": "Soundtrack",
  "Soundtracks : Vocal Pop": "Soundtrack",
  "Video : Video": "Instrumental",
  "World Music : Turkish Electronic": "World",
  "World Music : Turkish Folk": "World",
  "World Music : Turkish Pop": "World",
  "World Music : Turkish Rock": "World",
  "World Music : Turkish World": "World",
  "World Music : World Music": "World"
}*/

export const state51GenreMapping: any = {
  "8-Bit": ["Electronic", "8-Bit"],
  Alternative: ["Alternative", ""],
  "Alternative : College Rock": ["Alternative Rock", "College Rock"],
  "Alternative : Indie Alternative": ["Alternative", "Indie Alternative"],
  "Ambient Pop": ["Pop", "Ambient Pop"],
  "Avant-Garde": ["Experimental", "Avant-Garde"],
  Blues: ["Blues", ""],
  "Blues : Blues Rock": ["Blues", "Blues Rock"],
  "Blues : Chicago Blues": ["Blues", "Chicago Blues"],
  "Blues : Contemporary Blues": ["Blues", "Contemporary Blues"],
  "Blues : Country Blues": ["Blues", "Country Blues"],
  "Blues : Soul/R&B": ["Blues", "Soul/R&B"],
  "Blues : Electric Blues": ["Blues", "Electric Blues"],
  "Blues : Punk Blues": ["Blues", "Punk Blues"],
  "Blues : Acoustic Blues": ["Blues", "Acoustic Blues"],
  "Blues : Soul Blues": ["Blues", "Soul Blues"],
  "Blues : Texas Blues": ["Blues", "Texas Blues"],
  "Blues : Traditional Blues": ["Blues", "Traditional Blues"],
  "Children's": ["Children's", ""],
  "Children's : Educational": ["Children's", "Educational"],
  "Children's : Lullabies": ["Children's", "Lullabies"],
  Chiptune: ["Electronic", "Chiptune"],
  Cinematic: ["Soundtrack", "Cinematic"],
  Classical: ["Classical", ""],
  "Classical : Baroque": ["Classical", "Baroque"],
  "Classical : Film Music": ["Classical", "Film Music"],
  "Classical : Classical Crossover": ["Classical", "Classical Crossover"],
  "Classical : Concerto": ["Classical", "Concerto"],
  "Classical : Contemporary Classical": ["Classical", "Contemporary Classical"],
  "Classical : Early Music": ["Classical", "Early Music"],
  "Classical : Other": ["Classical", "Other"],
  "Classical : Opera": ["Classical", "Opera"],
  "Classical : Romantic": ["Classical", "Romantic"],
  "Classical : Symphony": ["Classical", "Symphony"],
  Comedy: ["Comedy", ""],
  Country: ["Country", ""],
  "Country : Alt-Country": ["Country", "Alt-Country"],
  "Country : Americana": ["Country", "Americana"],
  "Country : Other": ["Country", "Other"],
  "Country : Contemporary Country": ["Country", "Contemporary Country"],
  "Country : Country Rock": ["Country", "Country Rock"],
  "Country : Honky Tonk": ["Country", "Honky Tonk"],
  "Country : Traditional Country": ["Country", "Traditional Country"],
  Electroacoustic: ["Electronic", "Electroacoustic"],
  Electronic: ["Electronic", ""],
  "Electronic : 2-Step Garage": ["Electronic", "2-Step Garage"],
  "Electronic : Acid House": ["Electronic", "Acid House"],
  "Electronic : Acid Techno": ["Electronic", "Acid Techno"],
  "Electronic : Ambient": ["Electronic", "Ambient"],
  "Electronic : Bass House": ["Electronic", "Bass House"],
  "Electronic : Big Beat": ["Electronic", "Big Beat"],
  "Electronic : Breakbeat": ["Electronic", "Breakbeat"],
  "Electronic : Dance": ["Electronic", "Dance"],
  "Electronic : Chillout": ["Electronic", "Chillout"],
  "Electronic : DJ": ["Electronic", "DJ"],
  "Electronic : Contemporary Electronic": ["Electronic", "Contemporary Electronic"],
  "Electronic : Dark Ambient": ["Electronic", "Dark Ambient"],
  "Electronic : Deep House": ["Electronic", "Deep House"],
  "Electronic : Detroit Techno": ["Electronic", "Detroit Techno"],
  "Electronic : Downtempo": ["Electronic", "Downtempo"],
  "Electronic : Drum & Bass": ["Electronic", "Drum & Bass"],
  "Electronic : Dubstep": ["Electronic", "Dubstep"],
  "Electronic : EDM": ["Electronic", "EDM"],
  "Electronic : Electro House": ["Electronic", "Electro House"],
  "Electronic : Electro Swing": ["Electronic", "Electro Swing"],
  "Electronic : Electroclash": ["Electronic", "Electroclash"],
  "Electronic : Experimental Electronic": ["Electronic", "Experimental Electronic"],
  "Electronic : Footwork": ["Electronic", "Footwork"],
  "Electronic : Future Bass": ["Electronic", "Future Bass"],
  "Electronic : Future Garage": ["Electronic", "Future Garage"],
  "Electronic : Future House": ["Electronic", "Future House"],
  "Electronic : Other": ["Electronic", "Other"],
  "Electronic : Glitch Hop": ["Electronic", "Glitch Hop"],
  "Electronic : Goa Trance": ["Electronic", "Goa Trance"],
  "Electronic : Hard Techno": ["Electronic", "Hard Techno"],
  "Electronic : Hard Trance": ["Electronic", "Hard Trance"],
  "Electronic : Hardcore": ["Electronic", "Hardcore"],
  "Electronic : Hardstyle": ["Electronic", "Hardstyle"],
  "Electronic : House": ["Electronic", "House"],
  "Electronic : Hypnotic": ["Electronic", "Hypnotic"],
  "Electronic : IDM": ["Electronic", "IDM"],
  "Electronic : Industrial Techno": ["Electronic", "Industrial Techno"],
  "Electronic : Jersey Club": ["Electronic", "Jersey Club"],
  "Electronic : Jungle": ["Electronic", "Jungle"],
  "Electronic : Liquid DnB": ["Electronic", "Liquid DnB"],
  "Electronic : Minimal Techno": ["Electronic", "Minimal Techno"],
  "Electronic : Moombahton": ["Electronic", "Moombahton"],
  "Electronic : Neurofunk": ["Electronic", "Neurofunk"],
  "Electronic : Nu-Disco": ["Electronic", "Nu-Disco"],
  "Electronic : Nu-Jazz": ["Electronic", "Nu-Jazz"],
  "Electronic : Progressive House": ["Electronic", "Progressive House"],
  "Electronic : Progressive Trance": ["Electronic", "Progressive Trance"],
  "Electronic : Psytrance": ["Electronic", "Psytrance"],
  "Electronic : Retrowave": ["Electronic", "Retrowave"],
  "Electronic : Speed Garage": ["Electronic", "Speed Garage"],
  "Electronic : Synthwave": ["Electronic", "Synthwave"],
  "Electronic : Tech House": ["Electronic", "Tech House"],
  "Electronic : Techno": ["Electronic", "Techno"],
  "Electronic : Traditional Electronic": ["Electronic", "Traditional Electronic"],
  "Electronic : Trance": ["Electronic", "Trance"],
  "Electronic : Trip-Hop": ["Electronic", "Trip-Hop"],
  "Electronic : Tropical Bass": ["Electronic", "Tropical Bass"],
  "Electronic : Tropical House": ["Electronic", "Tropical House"],
  "Electronic : UK Funky": ["Electronic", "UK Funky"],
  "Electronic : UK Garage": ["Electronic", "UK Garage"],
  "Electronic : Dance-Pop": ["Electronic", "Dance-Pop"],
  "Electronic : Deep Techno": ["Electronic", "Deep Techno"],
  "Electronic : Melodic House": ["Electronic", "Melodic House"],
  "Electronic : Organic House": ["Electronic", "Organic House"],
  Experimental: ["Experimental", ""],
  "Experimental : Avant-Garde": ["Experimental", "Avant-Garde"],
  "Experimental : Drone": ["Experimental", "Drone"],
  "Experimental : Musique Concrète": ["Experimental", "Musique Concrète"],
  "Experimental : Noise": ["Experimental", "Noise"],
  "Experimental : Sound Collage": ["Experimental", "Sound Collage"],
  "Field Recordings": ["Experimental", "Field Recordings"],
  "Fitness & Workout": ["Fitness & Workout", ""],
  "Fitness & Workout : Dance": ["Fitness & Workout", "Dance"],
  Folk: ["Folk", ""],
  "Folk : Acoustic": ["Folk", "Acoustic"],
  "Folk : Alternative Folk": ["Folk", "Alternative Folk"],
  "Folk : Contemporary Folk": ["Folk", "Contemporary Folk"],
  "Folk : Flamenco Folk": ["Folk", "Flamenco Folk"],
  "Folk : Indie Folk": ["Folk", "Indie Folk"],
  "Folk : Protest": ["Folk", "Protest"],
  "Folk : Scandinavian Folk": ["Folk", "Scandinavian Folk"],
  "Folk : Sea Shanties": ["Folk", "Sea Shanties"],
  "Folk : Sephardic": ["Folk", "Sephardic"],
  "Folk : Singer-Songwriter": ["Folk", "Singer-Songwriter"],
  "Folk : Traditional Folk": ["Folk", "Traditional Folk"],
  "Folk : Turkish Folk": ["Folk", "Turkish Folk"],
  "Hip-Hop/Rap : Contemporary Hip-Hop": ["Hip-Hop/Rap", "Contemporary Hip-Hop"],
  "Hip-Hop/Rap : Fusion Hip-Hop": ["Hip-Hop/Rap", "Fusion Hip-Hop"],
  "Hip-Hop/Rap : Traditional Hip-Hop": ["Hip-Hop/Rap", "Traditional Hip-Hop"],
  "Hip-Hop/Rap": ["Hip-Hop/Rap", ""],
  "Hip-Hop/Rap : Alternative Hip-Hop": ["Hip-Hop/Rap", "Alternative Hip-Hop"],
  "Hip-Hop/Rap : Boom Bap": ["Hip-Hop/Rap", "Boom Bap"],
  "Hip-Hop/Rap : R&B": ["Hip-Hop/Rap", "R&B"],
  "Hip-Hop/Rap : Cloud Rap": ["Hip-Hop/Rap", "Cloud Rap"],
  "Hip-Hop/Rap : Conscious Hip-Hop": ["Hip-Hop/Rap", "Conscious Hip-Hop"],
  "Hip-Hop/Rap : Other": ["Hip-Hop/Rap", "Other"],
  "Hip-Hop/Rap : Drill": ["Hip-Hop/Rap", "Drill"],
  "Hip-Hop/Rap : East Coast Hip-Hop": ["Hip-Hop/Rap", "East Coast Hip-Hop"],
  "Hip-Hop/Rap : Emo Rap": ["Hip-Hop/Rap", "Emo Rap"],
  "Hip-Hop/Rap : Freestyle": ["Hip-Hop/Rap", "Freestyle"],
  "Hip-Hop/Rap : Gangsta Rap": ["Hip-Hop/Rap", "Gangsta Rap"],
  "Hip-Hop/Rap : Grime": ["Hip-Hop/Rap", "Grime"],
  "Hip-Hop/Rap : Hip House": ["Hip-Hop/Rap", "Hip House"],
  "Hip-Hop/Rap : Hip-Hop Soul": ["Hip-Hop/Rap", "Hip-Hop Soul"],
  "Hip-Hop/Rap : Instrumental Hip-Hop": ["Hip-Hop/Rap", "Instrumental Hip-Hop"],
  "Hip-Hop/Rap : Latin Trap": ["Hip-Hop/Rap", "Latin Trap"],
  "Hip-Hop/Rap : Lo-Fi Hip-Hop": ["Hip-Hop/Rap", "Lo-Fi Hip-Hop"],
  "Hip-Hop/Rap : New School Hip-Hop": ["Hip-Hop/Rap", "New School Hip-Hop"],
  "Hip-Hop/Rap : Old School Hip-Hop": ["Hip-Hop/Rap", "Old School Hip-Hop"],
  "Hip-Hop/Rap : Party Rap": ["Hip-Hop/Rap", "Party Rap"],
  "Hip-Hop/Rap : Phonk": ["Hip-Hop/Rap", "Phonk"],
  "Hip-Hop/Rap : Rap": ["Hip-Hop/Rap", "Rap"],
  "Hip-Hop/Rap : Rap Metal Crossover": ["Hip-Hop/Rap", "Rap Metal Crossover"],
  "Hip-Hop/Rap : Southern Hip-Hop": ["Hip-Hop/Rap", "Southern Hip-Hop"],
  "Hip-Hop/Rap : Trap": ["Hip-Hop/Rap", "Trap"],
  "Hip-Hop/Rap : Trap Metal": ["Hip-Hop/Rap", "Trap Metal"],
  "Hip-Hop/Rap : Turntablism": ["Hip-Hop/Rap", "Turntablism"],
  "Hip-Hop/Rap : UK Drill": ["Hip-Hop/Rap", "UK Drill"],
  "Hip-Hop/Rap : Underground Hip-Hop": ["Hip-Hop/Rap", "Underground Hip-Hop"],
  "Hip-Hop/Rap : West Coast Hip-Hop": ["Hip-Hop/Rap", "West Coast Hip-Hop"],
  Holiday: ["Holiday", ""],
  "Holiday : Christmas": ["Holiday", "Christmas"],
  "House : Contemporary House": ["Electronic", "Contemporary House"],
  "House : Traditional House": ["Electronic", "Traditional House"],
  Industrial: ["Experimental", ""],
  "Industrial : EBM": ["Experimental", "EBM"],
  "Industrial : Power Noise": ["Experimental", "Power Noise"],
  Jazz: ["Jazz", ""],
  "Jazz : Acid Jazz": ["Jazz", "Acid Jazz"],
  "Jazz : Bebop": ["Jazz", "Bebop"],
  "Jazz : Big Band": ["Jazz", "Big Band"],
  "Jazz : Contemporary Jazz": ["Jazz", "Contemporary Jazz"],
  "Jazz : Cool Jazz": ["Jazz", "Cool Jazz"],
  "Jazz : Free Jazz": ["Jazz", "Free Jazz"],
  "Jazz : Fusion": ["Jazz", "Fusion"],
  "Jazz : Gypsy Jazz": ["Jazz", "Gypsy Jazz"],
  "Jazz : Jazz/Blues": ["Jazz", "Jazz/Blues"],
  "Jazz : Jazz Funk": ["Jazz", "Jazz Funk"],
  "Jazz : Latin Jazz": ["Jazz", "Latin Jazz"],
  "Jazz : Other": ["Jazz", "Other"],
  "Jazz : Classic Jazz": ["Jazz", "Classic Jazz"],
  "Jazz : Smooth Jazz": ["Jazz", "Smooth Jazz"],
  "Jazz : Traditional Jazz": ["Jazz", "Traditional Jazz"],
  "Jazz : Vocal Jazz": ["Jazz", "Vocal Jazz"],
  Latin: ["Latin", ""],
  "Latin : Bachata": ["Latin", "Bachata"],
  "Latin : Banda": ["Latin", "Banda"],
  "Latin : Bolero": ["Latin", "Bolero"],
  "Latin : Bossa Nova": ["Latin", "Bossa Nova"],
  "Latin : Contemporary Latin": ["Latin", "Contemporary Latin"],
  "Latin : Cumbia": ["Latin", "Cumbia"],
  "Latin : Forro": ["Latin", "Forro"],
  "Latin : Latin Trap": ["Latin", "Latin Trap"],
  "Latin : Mariachi": ["Latin", "Mariachi"],
  "Latin : Merengue": ["Latin", "Merengue"],
  "Latin : MPB": ["Latin", "MPB"],
  "Latin : Reggaeton": ["Latin", "Reggaeton"],
  "Latin : Salsa": ["Latin", "Salsa"],
  "Latin : Samba": ["Latin", "Samba"],
  "Latin : Sertanejo": ["Latin", "Sertanejo"],
  "Latin : Tango": ["Latin", "Tango"],
  "Latin : Traditional Latin": ["Latin", "Traditional Latin"],
  "Lo-Fi": ["Hip-Hop/Rap", "Lo-Fi"],
  Metal: ["Metal", ""],
  "Metal : Black Metal": ["Metal", "Black Metal"],
  "Metal : Other": ["Metal", "Other"],
  "Metal : Contemporary Metal": ["Metal", "Contemporary Metal"],
  "Metal : Death Metal": ["Metal", "Death Metal"],
  "Metal : Deathcore": ["Metal", "Deathcore"],
  "Metal : Gothic Metal": ["Metal", "Gothic Metal"],
  "Metal : Grindcore": ["Metal", "Grindcore"],
  "Metal : Groove Metal": ["Metal", "Groove Metal"],
  "Metal : Heavy Metal": ["Metal", "Heavy Metal"],
  "Metal : Industrial Metal": ["Metal", "Industrial Metal"],
  "Metal : Melodic Death Metal": ["Metal", "Melodic Death Metal"],
  "Metal : Metalcore": ["Metal", "Metalcore"],
  "Metal : Nu Metal": ["Metal", "Nu Metal"],
  "Metal : Post-Metal": ["Metal", "Post-Metal"],
  "Metal : Power Metal": ["Metal", "Power Metal"],
  "Metal : Progressive Metal": ["Metal", "Progressive Metal"],
  "Metal : Shoegaze Metal": ["Metal", "Shoegaze Metal"],
  "Metal : Speed Metal": ["Metal", "Speed Metal"],
  "Metal : Stoner Metal": ["Metal", "Stoner Metal"],
  "Metal : Symphonic Metal": ["Metal", "Symphonic Metal"],
  "Metal : Thrash Metal": ["Metal", "Thrash Metal"],
  "Metal : Traditional Metal": ["Metal", "Traditional Metal"],
  "Metal : Viking Metal": ["Metal", "Viking Metal"],
  Minimalism: ["Experimental", "Minimalism"],
  "Neo-Classical": ["Classical", "Neo-Classical"],
  "New Age": ["New Age", ""],
  "New Age : Ambient": ["New Age", "Ambient"],
  "New Age : Healing": ["New Age", "Healing"],
  "New Age : Meditation": ["New Age", "Meditation"],
  Podcast: ["Educational", "Podcast"],
  Pop: ["Pop", ""],
  "Pop : Alt-Pop": ["Pop", "Alt-Pop"],
  "Pop : Art Pop": ["Pop", "Art Pop"],
  "Pop : C-Pop": ["Pop", "C-Pop"],
  "Pop : Cantopop": ["Pop", "Cantopop"],
  "Pop : Chamber Pop": ["Pop", "Chamber Pop"],
  "Pop : Vocal": ["Pop", "Vocal"],
  "Pop : Contemporary Pop": ["Pop", "Contemporary Pop"],
  "Pop : Dance-Pop": ["Pop", "Dance-Pop"],
  "Pop : Dream Pop": ["Pop", "Dream Pop"],
  "Pop : Electro Pop Rock": ["Pop", "Electro Pop Rock"],
  "Pop : Electropop": ["Pop", "Electropop"],
  "Pop : Euro-Pop": ["Pop", "Euro-Pop"],
  "Pop : Fusion Pop": ["Pop", "Fusion Pop"],
  "Pop : Indie Dance-Pop": ["Pop", "Indie Dance-Pop"],
  "Pop : Indie Pop": ["Pop", "Indie Pop"],
  "Pop : J-Pop": ["Pop", "J-Pop"],
  "Pop : K-Pop": ["Pop", "K-Pop"],
  "Pop : Latin Pop": ["Pop", "Latin Pop"],
  "Pop : Other": ["Pop", "Other"],
  "Pop : Pop Rock": ["Pop", "Pop Rock"],
  "Pop : Pop Singer/Songwriter": ["Pop", "Pop Singer/Songwriter"],
  "Pop : Power Pop": ["Pop", "Power Pop"],
  "Pop : Synthpop": ["Pop", "Synthpop"],
  "Pop : Teen Pop": ["Pop", "Teen Pop"],
  "Pop : Traditional Pop": ["Pop", "Traditional Pop"],
  "Pop : Tropical Pop": ["Pop", "Tropical Pop"],
  "Pop : Viral Pop": ["Pop", "Viral Pop"],
  Psychedelic: ["Rock", "Psychedelic"],
  Punk: ["Punk", ""],
  "Punk : Anarcho-Punk": ["Punk", "Anarcho-Punk"],
  "Punk : Hardcore Punk": ["Punk", "Hardcore Punk"],
  "Punk : Oi!": ["Punk", "Oi!"],
  "Punk : Pop-Punk": ["Punk", "Pop-Punk"],
  "Punk : Post-Punk": ["Punk", "Post-Punk"],
  "Punk : Punk Rock": ["Punk", "Punk Rock"],
  "Punk : Ska-Punk": ["Punk", "Ska-Punk"],
  "R&B": ["R&B", ""],
  "R&B : Alternative R&B": ["R&B", "Alternative R&B"],
  "R&B : Blue-Eyed Soul": ["R&B", "Blue-Eyed Soul"],
  "R&B : Boogie": ["R&B", "Boogie"],
  "R&B : Soul": ["R&B", "Soul"],
  "R&B : Contemporary R&B": ["R&B", "Contemporary R&B"],
  "R&B : Disco": ["R&B", "Disco"],
  "R&B : Funk": ["R&B", "Funk"],
  "R&B : Fusion R&B": ["R&B", "Fusion R&B"],
  "R&B : Gospel Soul": ["R&B", "Gospel Soul"],
  "R&B : Motown": ["R&B", "Motown"],
  "R&B : Neo-Soul": ["R&B", "Neo-Soul"],
  "R&B : New Jack Swing": ["R&B", "New Jack Swing"],
  "R&B : P-Funk": ["R&B", "P-Funk"],
  "R&B : Other": ["R&B", "Other"],
  "R&B : Traditional R&B": ["R&B", "Traditional R&B"],
  "R&B : Trap Soul": ["R&B", "Trap Soul"],
  "R&B : Urban Contemporary": ["R&B", "Urban Contemporary"],
  Reggae: ["Reggae", ""],
  "Reggae : Contemporary Reggae": ["Reggae", "Contemporary Reggae"],
  "Reggae : Other": ["Reggae", "Other"],
  "Reggae : Dub": ["Reggae", "Dub"],
  "Reggae : Rocksteady": ["Reggae", "Rocksteady"],
  "Reggae : Roots Reggae": ["Reggae", "Roots Reggae"],
  "Reggae : Ska": ["Reggae", "Ska"],
  "Reggae : Traditional Reggae": ["Reggae", "Traditional Reggae"],
  Rock: ["Rock", ""],
  "Rock : Alternative Rock": ["Rock", "Alternative Rock"],
  "Rock : Arena Rock": ["Rock", "Arena Rock"],
  "Rock : Britpop": ["Rock", "Britpop"],
  "Rock : Classic Rock": ["Rock", "Classic Rock"],
  "Rock : Contemporary Rock": ["Rock", "Contemporary Rock"],
  "Rock : Country Rock": ["Rock", "Country Rock"],
  "Rock : Drone Rock": ["Rock", "Drone Rock"],
  "Rock : Experimental Rock": ["Rock", "Experimental Rock"],
  "Rock : Folk Rock": ["Rock", "Folk Rock"],
  "Rock : Fusion Rock": ["Rock", "Fusion Rock"],
  "Rock : Garage Punk": ["Rock", "Garage Punk"],
  "Rock : Garage Rock": ["Rock", "Garage Rock"],
  "Rock : Glam Rock": ["Rock", "Glam Rock"],
  "Rock : Gothic Rock": ["Rock", "Gothic Rock"],
  "Rock : Grunge": ["Rock", "Grunge"],
  "Rock : Hard Rock": ["Rock", "Hard Rock"],
  "Rock : Hard Rock Classic": ["Rock", "Hard Rock Classic"],
  "Rock : Indie Rock": ["Rock", "Indie Rock"],
  "Rock : Jam Band": ["Rock", "Jam Band"],
  "Rock : Rock'n Roll": ["Rock", "Rock'n Roll"],
  "Rock : Lo-Fi Rock": ["Rock", "Lo-Fi Rock"],
  "Rock : Math Rock": ["Rock", "Math Rock"],
  "Rock : Modern Rock": ["Rock", "Modern Rock"],
  "Rock : Noise Rock": ["Rock", "Noise Rock"],
  "Rock : Post-Punk": ["Rock", "Post-Punk"],
  "Rock : Pop-Rock": ["Rock", "Pop-Rock"],
  "Rock : Progressive Rock": ["Rock", "Progressive Rock"],
  "Rock : Rock Singer/Songwriter": ["Rock", "Rock Singer/Songwriter"],
  "Rock : Psychedelic Rock": ["Rock", "Psychedelic Rock"],
  "Rock : Psychobilly": ["Rock", "Psychobilly"],
  "Rock : Punk Rock": ["Rock", "Punk Rock"],
  "Rock : Retro Rock": ["Rock", "Retro Rock"],
  "Rock : Rockabilly": ["Rock", "Rockabilly"],
  "Rock : Southern Rock": ["Rock", "Southern Rock"],
  "Rock : Stoner Rock": ["Rock", "Stoner Rock"],
  "Rock : Surf Rock": ["Rock", "Surf Rock"],
  "Rock : Traditional Rock": ["Rock", "Traditional Rock"],
  Ska: ["Reggae", ""],
  "Singer & Songwriter": ["Singer/Songwriter", ""],
  "Ska : Reggae-Ska Fusion": ["Reggae", "Reggae-Ska Fusion"],
  "Ska : Ska Revival": ["Reggae", "Ska Revival"],
  "Soul : Contemporary Soul": ["Soul", "Contemporary Soul"],
  "Soul : Fusion Soul": ["Soul", "Fusion Soul"],
  "Soul : Modern Soul": ["Soul", "Modern Soul"],
  "Soul : Neo Soul Revival": ["Soul", "Neo Soul Revival"],
  "Soul : Soul": ["Soul", "Soul"],
  "Soul : LoFi": ["Soul", "LoFi"],
  "Soul : Traditional Soul": ["Soul", "Traditional Soul"],
  Soundtrack: ["Soundtrack", ""],
  "Soundtracks : Contemporary Soundtracks": ["Soundtrack", "Contemporary Soundtrack"],
  "Soundtracks : Film Soundtracks": ["Soundtrack", "Film Soundtracks"],
  "Soundtracks : Game Soundtracks": ["Soundtrack", "Game Soundtrack"],
  "Soundtracks : Musical Theatre": ["Soundtrack", "Musical Theatre"],
  "Soundtracks : Other": ["Soundtrack", "Other"],
  "Soundtracks : Traditional Soundtracks": ["Soundtrack", "Traditional Soundtrack"],
  "Soundtracks : TV Soundtracks": ["Soundtrack", "TV Soundtrack"],
  "Spoken Word": ["Spoken Word", ""],
  "Techno : Contemporary Techno": ["Electronic", "Contemporary Techno"],
  "Techno : Traditional Techno": ["Electronic", "Traditional Techno"],
  "Trance : Contemporary Trance": ["Electronic", "Contemporary Trance"],
  "Trance : Traditional Trance": ["Electronic", "Traditional Trance"],
  "Instrumental : Instrumental": ["Instrumental", ""],
  "Video Game Music": ["Soundtrack", "Video Game Music"],
  World: ["World", ""],
  "World : Arabesque": ["World", "Arabesque"],
  "World : Turkish Rap": ["World", "Turkish Rap"],
  "World : Afrobeat": ["Hip-Hop/Rap", "Afrobeat"],
  "World : Afropop": ["Pop", "Afropop"],
  "World : Amapiano": ["World", "Amapiano"],
  "World : Anatolian Rock": ["World", "Anatolian Rock"],
  "World : Arabic Classical": ["World", "Arabic Classical"],
  "World : Arabic Pop": ["World", "Arabic Pop"],
  "World : Balkan Folk": ["World", "Balkan Folk"],
  "World : Bhangra": ["World", "Bhangra"],
  "World : Bollywood": ["World", "Bollywood"],
  "World : Cantonese Pop": ["World", "Cantonese Pop"],
  "World : Celtic Folk": ["World", "Celtic Folk"],
  "World : Chinese Pop": ["World", "Chinese Pop"],
  "World : Contemporary World": ["World", "Contemporary World"],
  "World : Fado": ["World", "Fado"],
  "World : Flamenco": ["World", "Flamenco"],
  "World : Gqom": ["World", "Gqom"],
  "World : Turkish Folk": ["World", "Turkish Folk"],
  "World : Turkish Pop": ["World", "Turkish Pop"],
  "World Music : World Music": ["World", ""],
  "World Music : Turkish Rock": ["World", "Turkish Rock"],
  "World Music : Highlife": ["World", "Highlife"],
  "World Music : Indian Classical": ["World", "Indian Classical"],
  "World Music : J-Pop": ["World", "J-Pop"],
  "World Music : K-Pop": ["World", "K-Pop"],
  "World Music : Kwaito": ["World", "Kwaito"],
  "World Music : Mandopop": ["World", "Mandopop"],
  "World Music : Turkish World": ["World", "Turkish World"],
  "World Music : Persian Traditional": ["World", "Persian Traditional"],
  "World Music : Punjabi Pop": ["World", "Punjabi Pop"],
  "World Music : Rai": ["World", "Rai"],
  "World Music : Soukous": ["World", "Soukous"],
  "World Music : Traditional World": ["World", "Traditional World"],
  "Video : Video": ["World", ""]
}

export const state51MainGenreMapping = () => {
  const genreMapping: any = {}
  Object.keys(state51GenreMapping).map((genre) => {
    genreMapping[genre] = state51GenreMapping[genre][0]
  })
  return genreMapping
}

export const appleGenreMapping: any = {
  Blues: {
    value: "Blues",
    "Chicago Blues": {
      value: "Blues : Chicago Blues"
    },
    "Contemporary Blues": {
      value: "Blues : Contemporary Blues"
    },
    "Country Blues": {
      value: "Blues : Country Blues"
    },
    "Electric Blues": {
      value: "Blues : Electric Blues"
    }
  },
  Rock: {
    value: "Rock",
    "Rock & Roll": {
      value: "Rock : Rock'n Roll"
    },
    "Singer/Songwriter": {
      value: "Rock : Rock Singer/Songwriter"
    },
    "Turkish Rock": {
      value: "World Music : Turkish Rock"
    },
    "Death Metal/Black Metal": {
      value: "Metal : Black Metal"
    },
    Psychedelic: {
      value: "Psychedelic"
    },
    "Adult Alternative": {
      value: "Rock : Alternative Rock"
    },
    "Arena Rock": {
      value: "Rock : Arena Rock"
    },
    "Glam Rock": {
      value: "Rock : Glam Rock"
    },
    "Hard Rock": {
      value: "Rock : Hard Rock"
    },
    "Jam Bands": {
      value: "Rock : Jam Band"
    },
    "Prog-Rock/Art Rock": {
      value: "Rock : Progressive Rock"
    },
    Rockabilly: {
      value: "Rock : Rockabilly"
    },
    "Southern Rock": {
      value: "Rock : Southern Rock"
    },
    Surf: {
      value: "Rock : Surf Rock"
    },
    "American Trad Rock": {
      value: "Rock : Traditional Rock"
    }
  },
  "R&B/Soul": {
    value: "R&B : Soul",
    "Neo-Soul": {
      value: "R&B : Neo-Soul"
    },
    "Contemporary R&B": {
      value: "R&B : Contemporary R&B"
    },
    Disco: {
      value: "R&B : Boogie"
    },
    Funk: {
      value: "R&B : Funk"
    },
    Motown: {
      value: "R&B : Motown"
    },
    "Hip-Hop/Rap": {
      value: "Hip-Hop/Rap : R&B"
    }
  },
  "Children's Music": {
    value: "Children's"
  },
  Classical: {
    value: "Classical",
    "Art Song": {
      value: "Classical : Film Music"
    },
    "Baroque Era": {
      value: "Classical : Baroque"
    },
    "Classical Crossover": {
      value: "Classical : Classical Crossover"
    },
    "Contemporary Era": {
      value: "Classical : Contemporary Classical"
    },
    "Medieval Era": {
      value: "Classical : Early Music"
    },
    Opera: {
      value: "Classical : Opera"
    },
    "Romantic Era": {
      value: "Classical : Romantic"
    },
    Orchestral: {
      value: "Classical : Symphony"
    },
    Minimalism: {
      value: "Minimalism"
    },
    "Modern Era": {
      value: "Neo-Classical"
    }
  },
  Country: {
    value: "Country",
    "Contemporary Country": {
      value: "Country : Other"
    },
    "Alternative Country": {
      value: "Country : Alt-Country"
    },
    Americana: {
      value: "Country : Americana"
    },
    "Honky Tonk": {
      value: "Country : Honky Tonk"
    },
    "Traditional Country": {
      value: "Country : Traditional Country"
    }
  },
  Dance: {
    value: "Electronic : Dance",
    House: {
      value: "Electronic : House"
    },
    Garage: {
      value: "Electronic : 2-Step Garage"
    },
    Techno: {
      value: "Electronic : Techno"
    },
    "Jungle/Drum'n'bass": {
      value: "Electronic : Drum & Bass"
    },
    Trance: {
      value: "Electronic : Trance"
    },
    Hardcore: {
      value: "Electronic : Hardcore"
    }
  },
  Electronic: {
    value: "Electronic",
    Downtempo: {
      value: "Electronic : Downtempo"
    },
    Electronica: {
      value: "Electronic : Electro House"
    },
    "IDM/Experimental": {
      value: "Electronic : IDM"
    },
    Ambient: {
      value: "Electronic : Ambient"
    },
    Bass: {
      value: "Electronic : Bass House"
    },
    Dubstep: {
      value: "Electronic : Dubstep"
    },
    Industrial: {
      value: "Electronic : Industrial Techno"
    }
  },
  Folk: {
    value: "Folk"
  },
  "Singer/Songwriter": {
    value: "Singer & Songwriter",
    "Contemporary Folk": {
      value: "Folk : Contemporary Folk"
    },
    "Traditional Folk": {
      value: "Folk : Traditional Folk"
    },
    "Folk-Rock": {
      value: "Rock : Country Rock"
    }
  },
  "Hip-Hop": {
    value: "Hip-Hop/Rap",
    Rap: {
      value: "Hip-Hop/Rap : Rap"
    }
  },
  Rap: {
    value: "Hip-Hop/Rap",
    "Hip-Hop/Rap": {
      value: "Hip-Hop/Rap : Rap"
    }
  },
  "Hip-Hop/Rap": {
    value: "Hip-Hop/Rap",
    Rap: {
      value: "Hip-Hop/Rap : Rap"
    },
    "Underground Rap": {
      value: "Hip-Hop/Rap : Underground Hip-Hop"
    },
    "Hip-Hop": {
      value: "Hip-Hop/Rap"
    },
    "Gangsta Rap": {
      value: "Hip-Hop/Rap : Gangsta Rap"
    },
    "Latin Rap": {
      value: "Hip-Hop/Rap : Latin Trap"
    },
    "Old School Rap": {
      value: "Hip-Hop/Rap : Old School Hip-Hop"
    },
    "UK Hip Hop": {
      value: "Hip-Hop/Rap : UK Drill"
    },
    "West Coast Rap": {
      value: "Hip-Hop/Rap : West Coast Hip-Hop"
    },
    "Turkish Hip-Hop/Rap": {
      value: "World : Turkish Rap"
    }
  },
  Jazz: {
    value: "Jazz",
    "Contemporary Jazz": {
      value: "Jazz : Contemporary Jazz"
    },
    Bebop: {
      value: "Jazz : Bebop"
    },
    "Big Band": {
      value: "Jazz : Big Band"
    },
    "Cool Jazz": {
      value: "Jazz : Cool Jazz"
    },
    "Avant-Garde Jazz": {
      value: "Jazz : Free Jazz"
    },
    Fusion: {
      value: "Jazz : Fusion"
    },
    "Smooth Jazz": {
      value: "Jazz : Smooth Jazz"
    },
    "Trad Jazz": {
      value: "Jazz : Traditional Jazz"
    },
    "Vocal Jazz": {
      value: "Jazz : Vocal Jazz"
    }
  },
  Latin: {
    value: "Latin",
    "Latin Jazz": {
      value: "Jazz : Latin Jazz"
    },
    "Contemporary Latin": {
      value: "Latin : Contemporary Latin"
    },
    "Regional Mexicano": {
      value: "Latin : Mariachi"
    },
    "Salsa y Tropical": {
      value: "Latin : Salsa"
    },
    "Pop in Spanish": {
      value: "Pop : Latin Pop"
    }
  },
  "New Age": {
    value: "New Age",
    Healing: {
      value: "New Age : Healing"
    },
    Meditation: {
      value: "New Age : Meditation"
    }
  },
  Alternative: {
    value: "Alternative",
    "College Rock": {
      value: "Alternative : College Rock"
    },
    "Indie Rock": {
      value: "Alternative : Indie Alternative"
    },
    "Pop Punk": {
      value: "Punk : Pop-Punk"
    },
    "Goth Rock": {
      value: "Rock : Gothic Rock"
    },
    Grunge: {
      value: "Rock : Grunge"
    }
  },
  "K-Pop": {
    value: "Pop : K-Pop"
  },
  "Turkish Pop": {
    value: "Pop",
    Pop: {
      value: "Pop"
    }
  },
  Pop: {
    value: "Pop",
    "Pop/Rock": {
      value: "Rock : Pop-Rock"
    },
    "Turkish Pop": {
      value: "World : Turkish Pop"
    },
    Cantopop: {
      value: "Pop : Cantopop"
    },
    "Adult Contemporary": {
      value: "Pop : Contemporary Pop"
    },
    "K-Pop": {
      value: "Pop : K-Pop"
    },
    "Teen Pop": {
      value: "Pop : Teen Pop"
    },
    Britpop: {
      value: "Rock : Britpop"
    },
    Mandopop: {
      value: "World Music : Mandopop"
    }
  },
  Reggae: {
    value: "Reggae",
    Ska: {
      value: "Reggae : Ska"
    },
    Dub: {
      value: "Reggae : Dub"
    },
    "Roots Reggae": {
      value: "Reggae : Roots Reggae"
    }
  },
  Soundtrack: {
    value: "Soundtrack",
    "TV Soundtrack": {
      value: "Soundtracks : TV Soundtracks"
    },
    "Video Game": {
      value: "Soundtracks : Game Soundtracks"
    },
    Musicals: {
      value: "Soundtracks : Musical Theatre"
    }
  },
  Turkish: {
    value: "World Music : Turkish World",
    Arabesk: {
      value: "World : Arabesque"
    }
  },
  Worldwide: {
    value: "World Music : World Music",
    Tango: {
      value: "Latin : Tango"
    },
    "Celtic Folk": {
      value: "World : Celtic Folk"
    },
    Fado: {
      value: "World : Fado"
    },
    Flamenco: {
      value: "World : Flamenco"
    }
  },
  "Fitness & Workout": {
    value: "Fitness & Workout"
  },
  Instrumental: {
    value: "Ambient Pop"
  },
  "Children's Stories": {
    value: "Children's : Educational"
  },
  "Children's Lullabies": {
    value: "Children's : Lullabies"
  },
  Comedy: {
    value: "Comedy"
  },
  Holiday: {
    value: "Holiday"
  },
  "Christian & Gospel": {
    value: "Holiday : Christmas"
  },
  Cuban: {
    value: "Cuban",
    Bolero: {
      value: "Latin : Bolero"
    }
  },
  Brazilian: {
    value: "Brazilian",
    "Bossa Nova": {
      value: "Latin : Bossa Nova"
    },
    Forró: {
      value: "Latin : Forro"
    },
    Samba: {
      value: "Latin : Samba"
    },
    Sertanejo: {
      value: "Latin : Sertanejo"
    }
  },
  "Spoken Word": {
    value: "Podcast"
  },
  "J-Pop": {
    value: "Pop : J-Pop"
  },
  Vocal: {
    value: "Vocal",
    "Traditional Pop": {
      value: "Pop : Traditional Pop"
    },
    "Vocal Pop": {
      value: "Pop : Vocal"
    }
  },
  African: {
    value: "African",
    Afrobeats: {
      value: "World : Afrobeat"
    },
    "Afro-Pop": {
      value: "World : Afropop"
    },
    Amapiano: {
      value: "World : Amapiano"
    },
    Highlife: {
      value: "World Music : Highlife"
    },
    Kwaito: {
      value: "World Music : Kwaito"
    },
    Soukous: {
      value: "World Music : Soukous"
    }
  },
  Arabic: {
    value: "World : Arabic Pop",
    "Arabic Pop": {
      value: "World : Arabic Pop"
    },
    "Maghreb Rai": {
      value: "World Music : Rai"
    }
  },
  Indian: {
    value: "Indian",
    Bollywood: {
      value: "World : Bollywood"
    },
    "Indian Classical": {
      value: "World Music : Indian Classical"
    }
  },
  Chinese: {
    value: "World : Chinese Pop"
  }
}

export const state51LanguageMapping = {
  Acoli: "No linguistic content - zxx",
  Afrikaans: "Afrikaans - afr",
  Akan: "No linguistic content - zxx",
  Amharic: "No linguistic content - zxx",
  Arabic: "Arabic - ara",
  Armenian: "No linguistic content - zxx",
  Baatonum: "No linguistic content - zxx",
  Bambara: "No linguistic content - zxx",
  Basque: "No linguistic content - zxx",
  Bassa: "No linguistic content - zxx",
  Belarusian: "No linguistic content - zxx",
  Bengali: "Bengali - ben",
  Bete: "No linguistic content - zxx",
  Bhojpuri: "No linguistic content - zxx",
  Bosnian: "No linguistic content - zxx",
  Breton: "No linguistic content - zxx",
  Bulgarian: "Bulgarian - bul",
  Cantonese: "No linguistic content - zxx",
  Catalan: "Catalan or Valencian - cat",
  "Central Huasteca Nahuatl": "No linguistic content - zxx",
  Chinese: "Chinese - zho",
  "Chinese (Simplified)": "Chinese - zho",
  "Chinese (Traditional)": "Yue Chinese - yue",
  "Church Slavic": "No linguistic content - zxx",
  Corsican: "No linguistic content - zxx",
  "Creole (Guadeloupe)": "No linguistic content - zxx",
  "Creole (Martinique)": "No linguistic content - zxx",
  "Creole (Reunion)": "No linguistic content - zxx",
  Croatian: "Croatian - hrv",
  Czech: "Czech - ces",
  Danish: "Danish - dan",
  Ditammari: "No linguistic content - zxx",
  Duala: "No linguistic content - zxx",
  Dutch: "Dutch or Flemish - nld",
  "Dyula (Burkina Faso)": "No linguistic content - zxx",
  "Dyula (Côte d'Ivoire)": "No linguistic content - zxx",
  Dzongkha: "No linguistic content - zxx",
  English: "English - eng",
  Estonian: "Estonian - est",
  Fanti: "No linguistic content - zxx",
  Finnish: "Finnish - fin",
  Fon: "No linguistic content - zxx",
  French: "French - fra",
  "Fulah (Burkina Faso)": "No linguistic content - zxx",
  "Fulah (Guinea)": "No linguistic content - zxx",
  "Fulah (Mali)": "No linguistic content - zxx",
  "Fulah (Nigeria)": "No linguistic content - zxx",
  "Fulah (Senegal)": "No linguistic content - zxx",
  Fulfulde: "No linguistic content - zxx",
  Gaelic: "No linguistic content - zxx",
  Galician: "No linguistic content - zxx",
  Georgian: "No linguistic content - zxx",
  German: "German - deu",
  "Ghanaian Pidgin English": "No linguistic content - zxx",
  Greek: "Modern Greek (1453-) - ell",
  "Guianese Creole French": "No linguistic content - zxx",
  Gujarati: "No linguistic content - zxx",
  Haitian: "Haitian or Haitian Creole - hat",
  Haryanvi: "No linguistic content - zxx",
  Hebrew: "Hebrew - heb",
  Hindi: "Hindi - hin",
  "Humburi Senni Songhay": "No linguistic content - zxx",
  Hungarian: "Hungarian - hun",
  Icelandic: "Icelandic - isl",
  Igbo: "No linguistic content - zxx",
  Indonesian: "Indonesian - ind",
  Instrumental: "No linguistic content - zxx",
  Irish: "Irish - gle",
  Italian: "Italian - ita",
  Japanese: "Japanese - jpn",
  Kabyle: "No linguistic content - zxx",
  Kamba: "No linguistic content - zxx",
  Kannada: "No linguistic content - zxx",
  Kazakh: "Kazakh - kaz",
  Khmer: "No linguistic content - zxx",
  Kikuyu: "No linguistic content - zxx",
  Kimbundu: "No linguistic content - zxx",
  Korean: "Korean - kor",
  "Koyra Chiini Songhay": "No linguistic content - zxx",
  Lao: "Lao - lao",
  Latin: "Latin - lat",
  Latvian: "Latvian - lav",
  "Lingala (Angola)": "No linguistic content - zxx",
  "Lingala (Central African Republic)": "No linguistic content - zxx",
  "Lingala (Democratic Republic of the Congo)": "No linguistic content - zxx",
  "Lingala (Republic of the Congo)": "No linguistic content - zxx",
  Lithuanian: "Lithuanian - lit",
  Luo: "No linguistic content - zxx",
  Magahi: "No linguistic content - zxx",
  Maithili: "No linguistic content - zxx",
  Malagasy: "No linguistic content - zxx",
  Malay: "Malay - msa",
  Maltese: "No linguistic content - zxx",
  Mandinka: "No linguistic content - zxx",
  Maori: "No linguistic content - zxx",
  Marathi: "No linguistic content - zxx",
  Mongolian: "No linguistic content - zxx",
  Multilingual: "No linguistic content - zxx",
  Neapolitan: "No linguistic content - zxx",
  "Ngazidja Comorian": "No linguistic content - zxx",
  Njebi: "No linguistic content - zxx",
  "North Ndebele": "No linguistic content - zxx",
  "Northern Sotho": "No linguistic content - zxx",
  Norwegian: "Norwegian - nor",
  Nuer: "No linguistic content - zxx",
  Occitan: "No linguistic content - zxx",
  Odia: "No linguistic content - zxx",
  Persian: "Persian - fas",
  Polish: "Polish - pol",
  Portuguese: "Portuguese - por",
  Punjabi: "Panjabi or Punjabi - pan",
  Rajasthani: "No linguistic content - zxx",
  Romanian: "Romanian - ron",
  Russian: "Russian - rus",
  Sanskrit: "Sanskrit - san",
  Saramacan: "No linguistic content - zxx",
  Serbian: "No linguistic content - zxx",
  Shona: "No linguistic content - zxx",
  Slovak: "Slovak - slk",
  Slovenian: "Slovenian - slv",
  Somali: "No linguistic content - zxx",
  "Soninke (Gambia)": "No linguistic content - zxx",
  "Soninke (Mali)": "No linguistic content - zxx",
  "Soninke (Mauritania)": "No linguistic content - zxx",
  "Soninke (Senegal)": "No linguistic content - zxx",
  "Southern Samo": "No linguistic content - zxx",
  "Southern Sotho": "No linguistic content - zxx",
  Spanish: "Spanish or Castilian - spa",
  "Spanish (Latin America)*": "Spanish or Castilian - spa",
  "Susu (Guinea)": "No linguistic content - zxx",
  "Susu (Sierra Leone)": "No linguistic content - zxx",
  "Swahili (Democratic Republic of the Congo)": "No linguistic content - zxx",
  "Swahili (Kenya)": "No linguistic content - zxx",
  "Swahili (Uganda)": "No linguistic content - zxx",
  Swedish: "Swedish - swe",
  Tagalog: "Tagalog - tgl",
  Tamasheq: "No linguistic content - zxx",
  Tamil: "Tamil - tam",
  Telugu: "Telugu - tel",
  Thai: "Thai - tha",
  Tsonga: "No linguistic content - zxx",
  Tsotsitaal: "No linguistic content - zxx",
  Tswana: "No linguistic content - zxx",
  Turkish: "Turkish - tur",
  Twi: "No linguistic content - zxx",
  Ukrainian: "Ukrainian - ukr",
  Undefined: "No human vocals",
  Urdu: "Urdu - urd",
  "Varhadi-Nagpuri": "No linguistic content - zxx",
  Vietnamese: "Vietnamese - vie",
  Waama: "No linguistic content - zxx",
  Walloon: "No linguistic content - zxx",
  Welsh: "No linguistic content - zxx",
  "Wolof (Gambia)": "No linguistic content - zxx",
  "Wolof (Mauritania)": "No linguistic content - zxx",
  "Wolof (Senegal)": "No linguistic content - zxx",
  Xhosa: "No linguistic content - zxx",
  Yoruba: "No linguistic content - zxx",
  Zulu: "Zulu - zul",
  dmn: "No linguistic content - zxx"
}

export const NEW_RELEASE_TYPES = {
  LABEL_CAMP: "label_camp",
  BMV: "bmv",
  MESAM_MSG: "mesam_msg",
  EDITORIAL_PITCHING: "editorial_pitching",
  STATE_51: "state_51",
  MARKETING: "marketing"
}

export const USER_CREDIT_TYPES = {
  FREE: "free",
  ESSENTIALS: "essentials",
  STANDARD: "standard",
  PREMIUM: "premium",
  CUSTOM: "custom"
}

export const userCreditTypeOptions: KSelectOption[] = [
  { label: "Free", value: 1, value2: USER_CREDIT_TYPES.FREE },
  { label: "Essentials", value: 2, value2: USER_CREDIT_TYPES.ESSENTIALS },
  { label: "Standard", value: 3, value2: USER_CREDIT_TYPES.STANDARD },
  { label: "Premium", value: 4, value2: USER_CREDIT_TYPES.PREMIUM },
  { label: "Custom", value: 5, value2: USER_CREDIT_TYPES.CUSTOM }
]

export const RELEASE_STATUSES = {
  DRAFT: "draft",
  ACTIVE: "active",
  REVIEWING: "reviewing",
  ARCHIVED: "archived"
}

export const releaseStatusOptions = [
  { label: "Draft", value: RELEASE_STATUSES.DRAFT, icon: DraftIcon, iconColored: "/catalog_icons/draft-status.svg" },
  {
    label: "Active",
    value: RELEASE_STATUSES.ACTIVE,
    icon: ActiveIcon,
    iconColored: "/catalog_icons/active-status.svg"
  },
  {
    label: "Reviewing",
    value: RELEASE_STATUSES.REVIEWING,
    icon: ReviewingIcon,
    iconColored: "/catalog_icons/reviewing-status.svg"
  },
  {
    label: "Archived",
    value: RELEASE_STATUSES.ARCHIVED,
    icon: ArchivedIcon,
    iconColored: "/catalog_icons/archived-status.svg"
  }
]

export const countryIcons = {
  Afghanistan: AfghanistanIcon,
  Albania: AlbaniaIcon,
  Algeria: AlgeriaIcon,
  Andorra: AndorraIcon,
  Angola: AngolaIcon,
  Argentina: ArgentinaIcon,
  Armenia: ArmeniaIcon,
  Australia: AustraliaIcon,
  Austria: AustriaIcon,
  Azerbaijan: AzerbaijanIcon,
  Bahrain: BahrainIcon,
  Bangladesh: BangladeshIcon,
  Barbados: BarbadosIcon,
  Belarus: BelarusIcon,
  Belgium: BelgiumIcon,
  Bolivia: BoliviaIcon,
  "Bosnia and Herzegovina": BosniaAndHerzegovinaIcon,
  Brazil: BrazilIcon,
  "Brunei Darussalam": BruneiIcon,
  Bulgaria: BulgariaIcon,
  Cambodia: CambodiaIcon,
  Cameroon: CameroonIcon,
  Canada: CanadaIcon,
  Chile: ChileIcon,
  China: ChinaIcon,
  Colombia: ColombiaIcon,
  "Costa Rica": CostaRicaIcon,
  Cyprus: CyprusIcon,
  Croatia: CroatiaIcon,
  "Czech Republic": CzechRepublicIcon,
  "Democratic Republic of the Congo": DemocraticCongoIcon,
  Denmark: DenmarkIcon,
  Djibouti: DjiboutiIcon,
  "Dominican Republic": DominicanRepublicIcon,
  Ecuador: EcuadorIcon,
  Egypt: EgyptIcon,
  "El Salvador": ElSalvadorIcon,
  England: EnglandIcon,
  "Equatorial Guinea": EquatorialGuineaIcon,
  Eritrea: EritreaIcon,
  Estonia: EstoniaIcon,
  Ethiopia: EthiopiaIcon,
  Finland: FinlandIcon,
  France: FranceIcon,
  Gambia: GambiaIcon,
  Georgia: GeorgiaIcon,
  Germany: GermanyIcon,
  Ghana: GhanaIcon,
  Greece: GreeceIcon,
  Guam: GuamIcon,
  Guatemala: GuatemalaIcon,
  Guinea: GuineaIcon,
  Honduras: HondurasIcon,
  "Hong Kong": HongKongIcon,
  Hungary: HungaryIcon,
  Iceland: IcelandIcon,
  India: IndiaIcon,
  Indonesia: IndonesiaIcon,
  Iran: IranIcon,
  Iraq: IraqIcon,
  Ireland: IrelandIcon,
  "Isle of Man": IsleOfManIcon,
  Israel: IsraelIcon,
  Italy: ItalyIcon,
  "Ivory Coast": IvoryCoastIcon,
  Japan: JapanIcon,
  Jordan: JordanIcon,
  Kazakhstan: KazakhstanIcon,
  Kenya: KenyaIcon,
  Kosovo: KosovoIcon,
  Kuwait: KuwaitIcon,
  Kyrgyzstan: KyrgyzstanIcon,
  Latvia: LatviaIcon,
  Lebanon: LebanonIcon,
  Liberia: LiberiaIcon,
  Libya: LibyaIcon,
  Liechtenstein: LiechtensteinIcon,
  Lithuania: LithuaniaIcon,
  Luxembourg: LuxembourgIcon,
  Macao: MacaoIcon,
  Malaysia: MalaysiaIcon,
  Maldives: MaldivesIcon,
  Malta: MaltaIcon,
  Martinique: MartiniqueIcon,
  Mauritius: MauritiusIcon,
  Mexico: MexicoIcon,
  Moldova: MoldovaIcon,
  Mongolia: MongoliaIcon,
  Montenegro: MontenegroIcon,
  Morocco: MoroccoIcon,
  Mozambique: MozambiqueIcon,
  Namibia: NamibiaIcon,
  Nepal: NepalIcon,
  Netherlands: NetherlandsIcon,
  "New Zealand": NewZealandIcon,
  Nicaragua: NicaraguaIcon,
  Niger: NigerIcon,
  Nigeria: NigeriaIcon,
  "North Macedonia": NorthMacedoniaIcon,
  Norway: NorwayIcon,
  Oman: OmanIcon,
  Pakistan: PakistanIcon,
  Palestine: PalestineIcon,
  Panama: PanamaIcon,
  Paraguay: ParaguayIcon,
  Peru: PeruIcon,
  Philippines: PhilippinesIcon,
  Poland: PolandIcon,
  Portugal: PortugalIcon,
  "Puerto Rico": PuertoRicoIcon,
  Qatar: QatarIcon,
  Romania: RomaniaIcon,
  Russia: RussiaIcon,
  "Sao Tome and Principe": SaoTomeAndPrincipeIcon,
  "Saudi Arabia": SaudiArabiaIcon,
  Senegal: SenegalIcon,
  Serbia: SerbiaIcon,
  Seychelles: SeychellesIcon,
  Singapore: SingaporeIcon,
  Slovakia: SlovakiaIcon,
  Slovenia: SloveniaIcon,
  Somalia: SomaliaIcon,
  "South Africa": SouthAfricaIcon,
  "South Korea": SouthKoreaIcon,
  "South Sudan": SouthSudanIcon,
  Spain: SpainIcon,
  "Sri Lanka": SriLankaIcon,
  Sudan: SudanIcon,
  Suriname: SurinameIcon,
  Sweden: SwedenIcon,
  Switzerland: SwitzerlandIcon,
  Taiwan: TaiwanIcon,
  Tajikistan: TajikistanIcon,
  Tanzania: TanzaniaIcon,
  Thailand: ThailandIcon,
  Tunisia: TunisiaIcon,
  Turkey: TurkeyIcon,
  Turkmenistan: TurkmenistanIcon,
  Uganda: UgandaIcon,
  "United Kingdom": UnitedKingdomIcon,
  Ukraine: UkraineIcon,
  "United Arab Emirates": UnitedArabEmiratesIcon,
  Uruguay: UruguayIcon,
  "United States": UnitedStatesIcon,
  Uzbekistan: UzbekistanIcon,
  Venezuela: VenezuelaIcon,
  Vietnam: VietnamIcon,
  Wales: WalesIcon,
  Yemen: YemenIcon,
  Zimbabwe: ZimbabweIcon,
  "Other countries total": EarthIcon
}

export const initialHearingSources = {
  social_media: {
    label: lang.start_your_journey.how_hear_us_page.social_media,
    selected: false,
    suboptions: {
      facebook: { label: "Facebook", selected: false },
      instagram: { label: "Instagram", selected: false },
      twitter: { label: "X (Twitter)", selected: false },
      youtube: { label: "Youtube", selected: false },
      other: { label: lang.start_your_journey.how_hear_us_page.other, selected: false, value: "" }
    }
  },
  search_engine: {
    label: lang.start_your_journey.how_hear_us_page.search_engine,
    selected: false,
    suboptions: {
      google: { label: "Google", selected: false },
      bing: { label: "Bing", selected: false },
      yandex: { label: "Yandex", selected: false },
      other: { label: lang.start_your_journey.how_hear_us_page.other, selected: false, value: "" }
    }
  },
  email_newsletter: {
    label: lang.start_your_journey.how_hear_us_page.email_newsletter,
    selected: false
  },
  online_ads: {
    label: lang.start_your_journey.how_hear_us_page.online_ads,
    selected: false,
    suboptions: {
      facebook: { label: "Facebook ads", selected: false },
      instagram: { label: "Instagram ads", selected: false },
      youtube: { label: "Youtube ads", selected: false },
      other: { label: lang.start_your_journey.how_hear_us_page.other, selected: false }
    }
  },
  blogs_or_articles: {
    label: lang.start_your_journey.how_hear_us_page.blogs_or_articles,
    selected: false
  },
  affiliate_links: {
    label: lang.start_your_journey.how_hear_us_page.affiliate_links,
    selected: false
  },
  customer_review_sites: {
    label: lang.start_your_journey.how_hear_us_page.customer_review_sites,
    selected: false
  },
  other: {
    label: lang.start_your_journey.how_hear_us_page.other,
    selected: false,
    value: ""
  }
}

export enum NOTIFICATION_TYPES {
  OTHER = 1,
  RELEASE = 2
}

export enum REGISTERED_USER_TYPES {
  DEMO = "demo",
  SUBSCRIPTION = "subscription",
  NOT_ELIGIBLE = "not eligible"
}

export const adminCatalogTableColumns: AdminCatalogTableColumnType[] = [
  { name: "Release", visible: true },
  { name: "Release Date", visible: true },
  { name: "Genre", visible: true },
  { name: "Label", visible: true },
  { name: "UPC", visible: true },
  { name: "Status", visible: true },
  { name: "Label Camp", visible: true },
  { name: "Spotify Link", visible: true },
  { name: "Apple Music Link", visible: true },
  { name: "BMV", visible: true },
  { name: "MESAM MSG", visible: true },
  { name: "Editorial Pitching", visible: true },
  { name: "Marketing", visible: true },
  { name: "State51 ID", visible: true },
  { name: "State51 Delivery", visible: true },
  { name: "Show", visible: true },
  { name: "Upload", visible: true },
  { name: "Reload", visible: true }
]

export const userTypeOptions: KSelectOption[] = [
  { label: "Overview", value: -1, value2: "" },
  { label: "Super Admin", value: USER_ROLE.SuperAdmin, value2: "super-admin" },
  { label: "Distro Admin", value: USER_ROLE.DistroAdmin, value2: "distro-admin" },
  { label: "Distro Admin Assistant", value: USER_ROLE.DistroAdmin, value2: "distro-admin-assistant" },
  { label: "Accounting Admin", value: USER_ROLE.AccountingAdmin, value2: "accounting-admin" },
  { label: "Marketing Admin", value: USER_ROLE.MarketingAdmin, value2: "marketing-admin" },
  { label: "Custom Admin", value: USER_ROLE.CustomAdmin, value2: "custom-admin" },
  { label: "Artist", value: USER_ROLE.Artist, value2: "artist" },
  { label: "Affiliate", value: USER_ROLE.Affiliate, value2: "affiliate" },
  { label: "Collaborator", value: USER_ROLE.Collaborator, value2: "collaborator" },
  { label: "Brand Ambassador", value: USER_ROLE.BrandAmbassador, value2: "brand-ambassador" }
]

export enum AdminUserModalOptions {
  RELOAD,
  USER_TAKEDOWN,
  PAYMENT_METHODS,
  USER_CREDITS,
  USER_ADVANCE,
  AFFILIATE_FROM_LIST,
  AFFILIATE_TO_LIST,
  SEND_NOTIFICATION,
  USER_EXPENSE,
  ADMIN_PERMISSION
}

export const colorPaletteOptions = [
  "#37AD51",
  "#4A2FB7",
  "#303315",
  "#CC8F26",
  "#1F87AD",
  "#B72222",
  "#B74E6C",
  "#45D865",
  "#5D3BE5",
  "#F2FE67",
  "#FFB330",
  "#E52B2B",
  "#E56287",
  "#11A0FF",
  "#DAF7E0",
  "#DFD8FA",
  "#F6FE8C",
  "#FAD5D5",
  "#FAE0E7",
  "#C2EFFF"
]

export const platformColorPalette = {
  Spotify: "#1ED760",
  Instagram: "#C837AB",
  Facebook: "#0082FB",
  Apple: "#E85764"
}

export const USER_ADVANCE_TYPES = {
  DIRECT_PAYMENT: "direct_payment",
  MARKETING: "marketing"
}

export const UserAdvanceTypeTitle = {
  [USER_ADVANCE_TYPES.DIRECT_PAYMENT]: lang.reports.list_component.direct_payment,
  [USER_ADVANCE_TYPES.MARKETING]: lang.reports.list_component.marketing
}

export const ibanLengths = {
  AD: 24,
  AE: 23,
  AL: 28,
  AZ: 28,
  BA: 20,
  BE: 16,
  BF: 27,
  BG: 22,
  BH: 22,
  BI: 16,
  BJ: 28,
  BR: 29,
  BY: 28,
  CG: 27,
  CH: 21,
  CI: 28,
  CM: 27,
  CR: 22,
  CY: 28,
  CZ: 24,
  DE: 22,
  DJ: 27,
  DK: 18,
  DO: 28,
  EE: 20,
  EG: 27,
  ES: 24,
  FI: 18,
  FO: 18,
  FR: 27,
  GA: 27,
  GB: 22,
  GE: 22,
  GI: 23,
  GL: 18,
  GM: 27,
  GN: 27,
  GR: 27,
  GT: 28,
  GW: 25,
  HN: 28,
  HR: 21,
  HU: 28,
  IE: 22,
  IL: 23,
  IQ: 23,
  IR: 26,
  IS: 26,
  IT: 27,
  JO: 30,
  KZ: 20,
  KW: 30,
  LB: 28,
  LC: 32,
  LI: 21,
  LT: 20,
  LU: 20,
  LV: 21,
  MC: 27,
  MD: 24,
  ME: 22,
  MG: 27,
  MK: 19,
  ML: 28,
  MR: 27,
  MT: 31,
  MU: 30,
  MZ: 25,
  NE: 28,
  NI: 32,
  NL: 18,
  NO: 15,
  PK: 24,
  PL: 28,
  PS: 29,
  PT: 25,
  QA: 29,
  RO: 24,
  RS: 22,
  SA: 24,
  SC: 31,
  SE: 24,
  SI: 19,
  SK: 24,
  SM: 27,
  SN: 28,
  ST: 25,
  SV: 28,
  TD: 27,
  TG: 28,
  TL: 23,
  TN: 24,
  TR: 26,
  UA: 29,
  VA: 22,
  VG: 24,
  XK: 20
}

export const USER_BALANCE_EXPORT_HEADERS = [
  "Name",
  "Email",
  "Tax Type",
  "Company",
  "Payment Period",
  "Revenue Royalty ",
  "Revenue Affiliate",
  "Revenue Total",
  "Paid Royalty",
  "Paid Affiliate",
  "Paid Advance",
  "Paid Total",
  "Remaining Total",
  "Advance Total",
  "Remaining Advance",
  "Revenue Approved",
  "Threshold Total",
  "Threshold Progress"
]

export const ADMIN_PERMISSIONS = {
  USER_ASSET_READ: "1",
  USER_ASSET_WRITE: "2",
  USER_ASSET_RELOAD_REPORT: "3",
  USER_ASSET_SEND_NOTIFICATION: "4",
  USER_ASSET_ADVANCE: "5",
  USER_ASSET_GO_TO_PROFILE: "41",
  ASSET_REGISTRY_READ: "6",
  ASSET_REGISTRY_WRITE: "7",
  ASSET_REGISTRY_DELETE: "8",
  ASSET_REGISTRY_FORCE_UPLOAD: "9",
  RELEASE_SUBMISSION_READ: "10",
  RELEASE_SUBMISSION_WRITE: "11",
  RELEASE_SUBMISSION_UPLOAD_TRACK: "12",
  ROYALTY_REPORTS_READ: "13",
  ROYALTY_REPORTS_DOWNLOAD: "14",
  REPORTS_APPROVAL_READ: "15",
  REPORTS_APPROVAL_WRITE: "16",
  REPORTS_APPROVAL_REPORT_APPROVE: "17",
  REPORTS_APPROVAL_PAYMENT_APPROVE: "18",
  REPORTS_APPROVAL_UPDATE_CURRENCY: "19",
  REPORTS_APPROVAL_EXPORT: "20",
  FINANCE_REPORTING_USER_ADVANCE: "21",
  FINANCE_REPORTING_PL: "22",
  USER_TAKEDOWN_READ: "23",
  USER_TAKEDOWN_WRITE: "24",
  USER_TAKEDOWN_TAKEDOWN_METADATA: "25",
  USER_TAKEDOWN_UPLOAD_AUDIO_ASSET: "26",
  STATE_51_DELIVERIES_READ: "27",
  STATE_51_DELIVERIES_WRITE: "28",
  NEW_RELEASE_CODES_READ: "29",
  NEW_RELEASE_CODES_WRITE: "30",
  NEW_RELEASE_CODES_DELETE: "31",
  PLAYLIST_READ: "32",
  DAILY_TRENDS_READ: "33",
  DAILY_TRENDS_TOP_100: "34",
  DAILY_TRENDS_STREAMS_L3M: "35",
  DAILY_TRENDS_ROYALTY_L3M: "36",
  REGISTRATIONS_READ: "37",
  TERRITORY_DSP_LIST_READ: "38",
  TERRITORY_DSP_LIST_WRITE: "39",
  TERRITORY_DSP_LIST_DELETE: "40"
}

export const DISTRO_ADMIN_PERMISSION_LIST = [
  ADMIN_PERMISSIONS.USER_ASSET_READ,
  ADMIN_PERMISSIONS.USER_ASSET_WRITE,
  ADMIN_PERMISSIONS.USER_ASSET_RELOAD_REPORT,
  ADMIN_PERMISSIONS.USER_ASSET_SEND_NOTIFICATION,
  ADMIN_PERMISSIONS.USER_ASSET_ADVANCE,
  ADMIN_PERMISSIONS.USER_ASSET_GO_TO_PROFILE,
  ADMIN_PERMISSIONS.ASSET_REGISTRY_READ,
  ADMIN_PERMISSIONS.ASSET_REGISTRY_WRITE,
  ADMIN_PERMISSIONS.ASSET_REGISTRY_DELETE,
  ADMIN_PERMISSIONS.ASSET_REGISTRY_FORCE_UPLOAD,
  ADMIN_PERMISSIONS.RELEASE_SUBMISSION_READ,
  ADMIN_PERMISSIONS.RELEASE_SUBMISSION_WRITE,
  ADMIN_PERMISSIONS.RELEASE_SUBMISSION_UPLOAD_TRACK,
  ADMIN_PERMISSIONS.USER_TAKEDOWN_READ,
  ADMIN_PERMISSIONS.USER_TAKEDOWN_WRITE,
  ADMIN_PERMISSIONS.USER_TAKEDOWN_TAKEDOWN_METADATA,
  ADMIN_PERMISSIONS.USER_TAKEDOWN_UPLOAD_AUDIO_ASSET,
  ADMIN_PERMISSIONS.STATE_51_DELIVERIES_READ,
  ADMIN_PERMISSIONS.STATE_51_DELIVERIES_WRITE,
  ADMIN_PERMISSIONS.NEW_RELEASE_CODES_READ,
  ADMIN_PERMISSIONS.NEW_RELEASE_CODES_WRITE,
  ADMIN_PERMISSIONS.NEW_RELEASE_CODES_DELETE,
  ADMIN_PERMISSIONS.PLAYLIST_READ,
  ADMIN_PERMISSIONS.DAILY_TRENDS_READ,
  ADMIN_PERMISSIONS.DAILY_TRENDS_TOP_100,
  ADMIN_PERMISSIONS.DAILY_TRENDS_STREAMS_L3M,
  ADMIN_PERMISSIONS.DAILY_TRENDS_ROYALTY_L3M
]

export const DISTRO_ASSISTANT_ADMIN_PERMISSION_LIST = [
  ADMIN_PERMISSIONS.ASSET_REGISTRY_READ,
  ADMIN_PERMISSIONS.ASSET_REGISTRY_WRITE,
  ADMIN_PERMISSIONS.USER_TAKEDOWN_READ,
  ADMIN_PERMISSIONS.USER_TAKEDOWN_WRITE,
  ADMIN_PERMISSIONS.USER_TAKEDOWN_TAKEDOWN_METADATA,
  ADMIN_PERMISSIONS.USER_TAKEDOWN_UPLOAD_AUDIO_ASSET,
  ADMIN_PERMISSIONS.PLAYLIST_READ
]

export const ACCOUNTING_ADMIN_PERMISSION_LIST = [
  ADMIN_PERMISSIONS.USER_ASSET_READ,
  ADMIN_PERMISSIONS.USER_ASSET_ADVANCE,
  ADMIN_PERMISSIONS.ASSET_REGISTRY_READ,
  ADMIN_PERMISSIONS.ROYALTY_REPORTS_READ,
  ADMIN_PERMISSIONS.ROYALTY_REPORTS_DOWNLOAD,
  ADMIN_PERMISSIONS.REPORTS_APPROVAL_READ,
  ADMIN_PERMISSIONS.REPORTS_APPROVAL_WRITE,
  ADMIN_PERMISSIONS.REPORTS_APPROVAL_REPORT_APPROVE,
  ADMIN_PERMISSIONS.REPORTS_APPROVAL_PAYMENT_APPROVE,
  ADMIN_PERMISSIONS.REPORTS_APPROVAL_UPDATE_CURRENCY,
  ADMIN_PERMISSIONS.REPORTS_APPROVAL_EXPORT,
  ADMIN_PERMISSIONS.FINANCE_REPORTING_USER_ADVANCE,
  ADMIN_PERMISSIONS.FINANCE_REPORTING_PL
]

export const STATE_51_DELIVERY_STATUSES = {
  IN_PROGRESS: "in_progress",
  NOT_FOUND: "not_found",
  SUBMIT_ERROR: "submit_error",
  SUBMIT_COMPLETE: "submit_complete",
  DELIVERY_ERROR: "delivery_error",
  DELIVERY_COMPLETE: "delivery_complete"
}
